const getDefaultState = () => {
	return {
		body: {
			eid: "root",
			type: "body",
			children: [
				{
					eid: "HJVcKZ4ps",
					type: "fullwidth",
					children: [
						{
							eid: "sYkaY2f6UA",
							type: "multicolumn",
							children: [
								{
									eid: "xLzfmB9Wc1",
									type: "column",
									children: [
										{
											eid: "lIBq7Ire6",
											type: "text",
											attrs: {
												text: "<p style=\"text-align: center;\">Home</p>\n",
											},
											style: {
												backgroundColor: "",
												backgroundRepeat: "no-repeat",
												backgroundPosition: "center center",
												backgroundImage: "",
												backgroundSize: "auto",
												paddingLeft: "10px",
												paddingBottom: "5px",
												paddingRight: "10px",
												paddingTop: "5px",
												paragraphLineHeight: "20px",
												paragraphLetterSpacing: "normal",
												paragraphColor: "#FFFFFF",
												paragraphFontSize: "14px",
												paragraphFontFamily: "Helvetica Neue, Helvetica, Arial, Verdana, sans-serif",
												linkTextDecoration: "underline",
												linkColor: "#00c0e7",
												h3LineHeight: "27px",
												h3Color: "#000000",
												h3FontSize: "22px",
												h3FontFamily: "Georgia, Times, Times New Roman, serif",
												h3LetterSpacing: "normal",
												h2LineHeight: "34px",
												h2Color: "#000000",
												h2FontSize: "26px",
												h2FontFamily: "Georgia, Times, Times New Roman, serif",
												h2LetterSpacing: "normal",
												h1LineHeight: "40px",
												h1Color: "#000000",
												h1FontSize: "33px",
												h1FontFamily: "Georgia, Times, Times New Roman, serif",
												h1LetterSpacing: "normal",
												h6: {},
												h5: {},
												h4: {},
											},
											customData: null,
										},
									],
									attrs: {
										hideOnMobile: false,
										lock: false,
									},
									style: {
										width: "145px",
										backgroundColor: "",
										backgroundRepeat: "no-repeat",
										backgroundPosition: "center center",
										backgroundImage: "",
										backgroundSize: "auto",
									},
									customData: {},
								},
								{
									eid: "Udkuswx8O",
									type: "column",
									children: [
										{
											eid: "wiO6_AVpDu",
											type: "text",
											attrs: {
												text: "<p style=\"text-align: center;\">Shop</p>\n",
											},
											style: {
												backgroundColor: "",
												backgroundRepeat: "no-repeat",
												backgroundPosition: "center center",
												backgroundImage: "",
												backgroundSize: "auto",
												paddingLeft: "10px",
												paddingBottom: "5px",
												paddingRight: "10px",
												paddingTop: "5px",
												paragraphLineHeight: "20px",
												paragraphLetterSpacing: "normal",
												paragraphColor: "#FFFFFF",
												paragraphFontSize: "14px",
												paragraphFontFamily: "Helvetica Neue, Helvetica, Arial, Verdana, sans-serif",
												linkTextDecoration: "underline",
												linkColor: "#00c0e7",
												h3LineHeight: "27px",
												h3Color: "#000000",
												h3FontSize: "22px",
												h3FontFamily: "Georgia, Times, Times New Roman, serif",
												h3LetterSpacing: "normal",
												h2LineHeight: "34px",
												h2Color: "#000000",
												h2FontSize: "26px",
												h2FontFamily: "Georgia, Times, Times New Roman, serif",
												h2LetterSpacing: "normal",
												h1LineHeight: "40px",
												h1Color: "#000000",
												h1FontSize: "33px",
												h1FontFamily: "Georgia, Times, Times New Roman, serif",
												h1LetterSpacing: "normal",
												h6: {},
												h5: {},
												h4: {},
											},
											customData: null,
										},
									],
									attrs: {
										hideOnMobile: false,
										lock: false,
									},
									style: {
										width: "145px",
										backgroundColor: "",
										backgroundRepeat: "no-repeat",
										backgroundPosition: "center center",
										backgroundImage: "",
										backgroundSize: "auto",
									},
									customData: {},
								},
								{
									eid: "CvGO5hsEN",
									type: "column",
									children: [
										{
											eid: "1kt-fkeMAK",
											type: "text",
											attrs: {
												text: "<p style=\"text-align: center;\">Site</p>\n",
											},
											style: {
												backgroundColor: "",
												backgroundRepeat: "no-repeat",
												backgroundPosition: "center center",
												backgroundImage: "",
												backgroundSize: "auto",
												paddingLeft: "10px",
												paddingBottom: "5px",
												paddingRight: "10px",
												paddingTop: "5px",
												paragraphLineHeight: "20px",
												paragraphLetterSpacing: "normal",
												paragraphColor: "#FFFFFF",
												paragraphFontSize: "14px",
												paragraphFontFamily: "Helvetica Neue, Helvetica, Arial, Verdana, sans-serif",
												linkTextDecoration: "underline",
												linkColor: "#00c0e7",
												h3LineHeight: "27px",
												h3Color: "#000000",
												h3FontSize: "22px",
												h3FontFamily: "Georgia, Times, Times New Roman, serif",
												h3LetterSpacing: "normal",
												h2LineHeight: "34px",
												h2Color: "#000000",
												h2FontSize: "26px",
												h2FontFamily: "Georgia, Times, Times New Roman, serif",
												h2LetterSpacing: "normal",
												h1LineHeight: "40px",
												h1Color: "#000000",
												h1FontSize: "33px",
												h1FontFamily: "Georgia, Times, Times New Roman, serif",
												h1LetterSpacing: "normal",
												h6: {},
												h5: {},
												h4: {},
											},
											customData: null,
										},
									],
									attrs: {
										hideOnMobile: false,
										lock: false,
									},
									style: {
										width: "145px",
										backgroundColor: "",
										backgroundRepeat: "no-repeat",
										backgroundPosition: "center center",
										backgroundImage: "",
										backgroundSize: "auto",
									},
									customData: {},
								},
								{
									eid: "BWoYOGuu2",
									type: "column",
									children: [
										{
											eid: "6287u3TQVu",
											type: "text",
											attrs: {
												text: "<p style=\"text-align: center;\">Chat</p>\n",
											},
											style: {
												backgroundColor: "",
												backgroundRepeat: "no-repeat",
												backgroundPosition: "center center",
												backgroundImage: "",
												backgroundSize: "auto",
												paddingLeft: "10px",
												paddingBottom: "5px",
												paddingRight: "10px",
												paddingTop: "5px",
												paragraphLineHeight: "20px",
												paragraphLetterSpacing: "normal",
												paragraphColor: "#FFFFFF",
												paragraphFontSize: "14px",
												paragraphFontFamily: "Helvetica Neue, Helvetica, Arial, Verdana, sans-serif",
												linkTextDecoration: "underline",
												linkColor: "#00c0e7",
												h3LineHeight: "27px",
												h3Color: "#000000",
												h3FontSize: "22px",
												h3FontFamily: "Georgia, Times, Times New Roman, serif",
												h3LetterSpacing: "normal",
												h2LineHeight: "34px",
												h2Color: "#000000",
												h2FontSize: "26px",
												h2FontFamily: "Georgia, Times, Times New Roman, serif",
												h2LetterSpacing: "normal",
												h1LineHeight: "40px",
												h1Color: "#000000",
												h1FontSize: "33px",
												h1FontFamily: "Georgia, Times, Times New Roman, serif",
												h1LetterSpacing: "normal",
												h6: {},
												h5: {},
												h4: {},
											},
											customData: null,
										},
									],
									attrs: {
										hideOnMobile: false,
										lock: false,
									},
									style: {
										width: "145px",
										backgroundColor: "",
										backgroundRepeat: "no-repeat",
										backgroundPosition: "center center",
										backgroundImage: "",
										backgroundSize: "auto",
									},
									customData: {},
								},
							],
							attrs: {
								hideOnMobile: false,
								hideOnDesktop: false,
								stacking: "none",
								spacerBefore: "0px",
								spacerBetween: "0px",
								spacerAfter: "0px",
								spacerBeforeMobile: "0px",
								spacerBetweenMobile: "10px",
								spacerAfterMobile: "10px",
							},
							style: {
								backgroundColor: "",
								backgroundRepeat: "no-repeat",
								backgroundPosition: "center center",
								backgroundImage: "",
								backgroundSize: "auto",
							},
							customData: {},
						},
					],
					placeholder: [],
					attrs: {
						hideOnMobile: false,
						hideOnDesktop: false,
						lock: false,
						marker: "",
					},
					style: {
						backgroundColor: "",
						backgroundRepeat: "no-repeat",
						backgroundPosition: "center center",
						backgroundImage: "",
						backgroundSize: "auto",
						contentBackgroundColor: {
							reference: "SecondaryColor",
							default: "#5C9AEB",
						},
						contentBackgroundRepeat: "no-repeat",
						contentBackgroundPosition: "center center",
						contentBackgroundImage: "",
						contentBackgroundSize: "auto",
						contentBorderRadius: "0px",
						contentBorderLeftColor: "#121212",
						contentBorderLeftStyle: "solid",
						contentBorderLeftWidth: "0px",
						contentBorderBottomColor: "#121212",
						contentBorderBottomStyle: "solid",
						contentBorderBottomWidth: "0px",
						contentBorderRightColor: "#121212",
						contentBorderRightStyle: "solid",
						contentBorderRightWidth: "0px",
						contentBorderTopColor: "#121212",
						contentBorderTopStyle: "solid",
						contentBorderTopWidth: "0px",
						contentMarginLeft: "0px",
						contentMarginBottom: "0px",
						contentMarginRight: "0px",
						contentMarginTop: "0px",
						contentPaddingLeft: "10px",
						contentPaddingBottom: "10px",
						contentPaddingRight: "10px",
						contentPaddingTop: "10px",
						contentWidth: 600,
						bodyWidth: 600,
					},
					customData: {},
				},
				{
					eid: "LLHA5fiat",
					type: "fullwidth",
					children: [
						{
							eid: "S9VH-m-ZhA",
							type: "box",
							children: [
								{
									eid: "z6O2DKdQz",
									type: "box",
									children: [
										{
											eid: "wSwuZuIWw",
											type: "image",
											attrs: {
												title: "",
												link: "",
												altText: "",
												src: "https://placehold.co/167x36/ffffff/5C9AEB.png?text=Logo",
											},
											style: {
												fullWidthOnMobile: false,
												align: "center",
												lockedWidth: null,
												lockedHeight: null,
												maxHeight: "36px",
												maxWidth: "167px",
												width: "167px",
												backgroundColor: "",
												backgroundRepeat: "no-repeat",
												backgroundPosition: "center center",
												backgroundImage: "",
												backgroundSize: "auto",
												borderRadius: "0px",
												borderLeftColor: "#121212",
												borderLeftStyle: "solid",
												borderLeftWidth: "0px",
												borderBottomColor: "#121212",
												borderBottomStyle: "solid",
												borderBottomWidth: "0px",
												borderRightColor: "#121212",
												borderRightStyle: "solid",
												borderRightWidth: "0px",
												borderTopColor: "#121212",
												borderTopStyle: "solid",
												borderTopWidth: "0px",
												marginLeft: "0px",
												marginBottom: "0px",
												marginRight: "0px",
												marginTop: "0px",
												paddingLeft: "10px",
												paddingBottom: "5px",
												paddingRight: "10px",
												paddingTop: "5px",
											},
											customData: null,
										},
										{
											eid: "KdRj3P5VJzc",
											type: "text",
											attrs: {
												text: "<p style=\"text-align: center;\"><strong>Our Portfolio</strong></p>\n",
											},
											style: {
												backgroundColor: "",
												backgroundRepeat: "no-repeat",
												backgroundPosition: "center center",
												backgroundImage: "",
												backgroundSize: "auto",
												paddingLeft: "10px",
												paddingBottom: "0px",
												paddingRight: "10px",
												paddingTop: "5px",
												paragraphLineHeight: "55px",
												paragraphLetterSpacing: "normal",
												paragraphColor: "#ffffff",
												paragraphFontSize: "45px",
												paragraphFontFamily: "Helvetica Neue, Helvetica, Arial, Verdana, sans-serif",
												linkTextDecoration: "none",
												linkColor: "#a7a7a7",
												h3LineHeight: "22px",
												h3Color: "#ffffff",
												h3FontSize: "22px",
												h3FontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif",
												h3LetterSpacing: "normal",
												h2LineHeight: "26px",
												h2Color: "#ffffff",
												h2FontSize: "26px",
												h2FontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif",
												h2LetterSpacing: "normal",
												h1LineHeight: "32px",
												h1Color: "#ffffff",
												h1FontSize: "32px",
												h1FontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif",
												h1LetterSpacing: "normal",
												h6: {
													"line-height": "16px",
													color: "#000000",
													"font-size": "16px",
													"font-family": "arial",
												},
												h5: {
													"line-height": "18px",
													color: "#000000",
													"font-size": "18px",
													"font-family": "arial",
												},
												h4: {
													"line-height": "20px",
													color: "#000000",
													"font-size": "20px",
													"font-family": "arial",
												},
											},
											customData: null,
										},
										{
											eid: "60-OPIRcR49",
											type: "text",
											attrs: {
												text: "<p style=\"text-align: center;\">PERFECTLY SIMPLE DESIGN</p>",
											},
											style: {
												backgroundColor: "",
												backgroundRepeat: "no-repeat",
												backgroundPosition: "center center",
												backgroundImage: "",
												backgroundSize: "auto",
												paddingLeft: "10px",
												paddingBottom: "30px",
												paddingRight: "10px",
												paddingTop: "0px",
												paragraphLineHeight: "30px",
												paragraphLetterSpacing: "normal",
												paragraphColor: "#ffffff",
												paragraphFontSize: "15px",
												paragraphFontFamily: "Helvetica Neue, Helvetica, Arial, Verdana, sans-serif",
												linkTextDecoration: "none",
												linkColor: "#a7a7a7",
												h3LineHeight: "22px",
												h3Color: "#ffffff",
												h3FontSize: "22px",
												h3FontFamily: "Helvetica, Helvetica Neue, Arial",
												h3LetterSpacing: "normal",
												h2LineHeight: "26px",
												h2Color: "#ffffff",
												h2FontSize: "26px",
												h2FontFamily: "Helvetica, Helvetica Neue, Arial",
												h2LetterSpacing: "normal",
												h1LineHeight: "32px",
												h1Color: "#ffffff",
												h1FontSize: "32px",
												h1FontFamily: "Helvetica, Helvetica Neue, Arial",
												h1LetterSpacing: "normal",
												h6: {
													"line-height": "16px",
													color: "#000000",
													"font-size": "16px",
													"font-family": "arial",
												},
												h5: {
													"line-height": "18px",
													color: "#000000",
													"font-size": "18px",
													"font-family": "arial",
												},
												h4: {
													"line-height": "20px",
													color: "#000000",
													"font-size": "20px",
													"font-family": "arial",
												},
											},
											customData: null,
										},
										{
											eid: "FWDIuvUiKt",
											type: "multicolumn",
											children: [
												{
													eid: "CHEPvtkD5i",
													type: "column",
													children: [
														{
															eid: "wkj5VHXaV",
															type: "box",
															children: [
																{
																	eid: "2AHhADq2t",
																	type: "text",
																	attrs: {
																		text: "<p><strong>Professional</strong></p>\n",
																	},
																	style: {
																		backgroundColor: "",
																		backgroundRepeat: "no-repeat",
																		backgroundPosition: "center center",
																		backgroundImage: "",
																		backgroundSize: "auto",
																		paddingLeft: "10px",
																		paddingBottom: "5px",
																		paddingRight: "10px",
																		paddingTop: "10px",
																		paragraphLineHeight: "30px",
																		paragraphLetterSpacing: "normal",
																		paragraphColor: "#FFFFFF",
																		paragraphFontSize: "25px",
																		paragraphFontFamily: "Helvetica Neue, Helvetica, Arial, Verdana, sans-serif",
																		linkTextDecoration: "underline",
																		linkColor: "#00c0e7",
																		h3LineHeight: "27px",
																		h3Color: "#000000",
																		h3FontSize: "22px",
																		h3FontFamily: "Georgia, Times, Times New Roman, serif",
																		h3LetterSpacing: "normal",
																		h2LineHeight: "34px",
																		h2Color: "#000000",
																		h2FontSize: "26px",
																		h2FontFamily: "Georgia, Times, Times New Roman, serif",
																		h2LetterSpacing: "normal",
																		h1LineHeight: "40px",
																		h1Color: "#000000",
																		h1FontSize: "33px",
																		h1FontFamily: "Georgia, Times, Times New Roman, serif",
																		h1LetterSpacing: "normal",
																		h6: {},
																		h5: {},
																		h4: {},
																	},
																	customData: null,
																},
																{
																	eid: "k-fX1atyU",
																	type: "text",
																	attrs: {
																		text: "<p>STRATEGY TEAM</p>\n",
																	},
																	style: {
																		backgroundColor: "",
																		backgroundRepeat: "no-repeat",
																		backgroundPosition: "center center",
																		backgroundImage: "",
																		backgroundSize: "auto",
																		paddingLeft: "10px",
																		paddingBottom: "10px",
																		paddingRight: "10px",
																		paddingTop: "0px",
																		paragraphLineHeight: "20px",
																		paragraphLetterSpacing: "normal",
																		paragraphColor: "#D8EEF5",
																		paragraphFontSize: "15px",
																		paragraphFontFamily: "Helvetica Neue, Helvetica, Arial, Verdana, sans-serif",
																		linkTextDecoration: "underline",
																		linkColor: "#00c0e7",
																		h3LineHeight: "27px",
																		h3Color: "#000000",
																		h3FontSize: "22px",
																		h3FontFamily: "Georgia, Times, Times New Roman, serif",
																		h3LetterSpacing: "normal",
																		h2LineHeight: "34px",
																		h2Color: "#000000",
																		h2FontSize: "26px",
																		h2FontFamily: "Georgia, Times, Times New Roman, serif",
																		h2LetterSpacing: "normal",
																		h1LineHeight: "40px",
																		h1Color: "#000000",
																		h1FontSize: "33px",
																		h1FontFamily: "Georgia, Times, Times New Roman, serif",
																		h1LetterSpacing: "normal",
																		h6: {},
																		h5: {},
																		h4: {},
																	},
																	customData: null,
																},
																{
																	eid: "G6hw1u_xa",
																	type: "text",
																	attrs: {
																		text: "<p>Fusce maximus nunc ut quam aliquet, cursus tempus justo tincidunt. Vivamus quis magna molestie, pellentesque tellus ac, efficitur nibh,&nbsp;cursus tempus justo tincidunt.</p>\n",
																	},
																	style: {
																		backgroundColor: "",
																		backgroundRepeat: "no-repeat",
																		backgroundPosition: "center center",
																		backgroundImage: "",
																		backgroundSize: "auto",
																		paddingLeft: "10px",
																		paddingBottom: "10px",
																		paddingRight: "10px",
																		paddingTop: "10px",
																		paragraphLineHeight: "26px",
																		paragraphLetterSpacing: "normal",
																		paragraphColor: "#ffffff",
																		paragraphFontSize: "18px",
																		paragraphFontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif",
																		linkTextDecoration: "underline",
																		linkColor: "#00c0e7",
																		h3LineHeight: "27px",
																		h3Color: "#000000",
																		h3FontSize: "22px",
																		h3FontFamily: "Georgia, Times, Times New Roman, serif",
																		h3LetterSpacing: "normal",
																		h2LineHeight: "34px",
																		h2Color: "#000000",
																		h2FontSize: "26px",
																		h2FontFamily: "Georgia, Times, Times New Roman, serif",
																		h2LetterSpacing: "normal",
																		h1LineHeight: "40px",
																		h1Color: "#000000",
																		h1FontSize: "33px",
																		h1FontFamily: "Georgia, Times, Times New Roman, serif",
																		h1LetterSpacing: "normal",
																		h6: {},
																		h5: {},
																		h4: {},
																	},
																	customData: null,
																},
																{
																	eid: "1TrE5CYuV",
																	type: "button",
																	attrs: {
																		title: "",
																		text: "<p>Details</p>\n",
																		href: "",
																	},
																	style: {
																		lineHeight: "24px",
																		color: "#ffffff",
																		fontSize: "17px",
																		fontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif",
																		letterSpacing: "normal",
																		backgroundColor: {
																			reference: "SecondaryColor",
																			default: "#5C9AEB",
																		},
																		backgroundRepeat: "no-repeat",
																		backgroundPosition: "center center",
																		backgroundImage: "",
																		backgroundSize: "auto",
																		borderRadius: "5px",
																		borderLeftColor: "#121212",
																		borderLeftStyle: "solid",
																		borderLeftWidth: "0px",
																		borderBottomColor: "#121212",
																		borderBottomStyle: "solid",
																		borderBottomWidth: "0px",
																		borderRightColor: "#121212",
																		borderRightStyle: "solid",
																		borderRightWidth: "0px",
																		borderTopColor: "#121212",
																		borderTopStyle: "solid",
																		borderTopWidth: "0px",
																		marginLeft: "10px",
																		marginBottom: "20px",
																		marginRight: "10px",
																		marginTop: "20px",
																		paddingLeft: "25px",
																		paddingBottom: "9px",
																		paddingRight: "25px",
																		paddingTop: "9px",
																		hoverBackgroundColor: "",
																		sizeType: "FIT_TO_TEXT",
																		fullWidthOnMobile: false,
																		align: "left",
																	},
																	customData: null,
																},
															],
															attrs: {
																hideOnMobile: false,
																hideOnDesktop: false,
															},
															style: {
																backgroundColor: "transparent",
																backgroundRepeat: "repeat",
																backgroundPosition: "center top",
																backgroundImage: "",
																backgroundSize: "auto",
																borderRadius: "0px",
																borderLeftColor: "#121212",
																borderLeftStyle: "solid",
																borderLeftWidth: "0px",
																borderBottomColor: "#121212",
																borderBottomStyle: "solid",
																borderBottomWidth: "0px",
																borderRightColor: "#121212",
																borderRightStyle: "solid",
																borderRightWidth: "0px",
																borderTopColor: "#121212",
																borderTopStyle: "solid",
																borderTopWidth: "0px",
																marginLeft: "0px",
																marginBottom: "0px",
																marginRight: "0px",
																marginTop: "0px",
																paddingLeft: "10px",
																paddingBottom: "40px",
																paddingRight: "10px",
																paddingTop: "30px",
															},
															customData: {},
														},
													],
													attrs: {
														hideOnMobile: false,
														lock: false,
													},
													style: {
														width: "300px",
														backgroundColor: "",
														backgroundRepeat: "no-repeat",
														backgroundPosition: "center center",
														backgroundImage: "",
														backgroundSize: "auto",
													},
													customData: {},
												},
												{
													eid: "eLESTT4-2W",
													type: "column",
													children: [
														{
															eid: "PfcsfW5Ij",
															type: "box",
															children: [
																{
																	eid: "5SIYqtnWm",
																	type: "image",
																	attrs: {
																		title: "",
																		link: "",
																		altText: "",
																		src: "https://placehold.co/300x453/ededed/5C9AEB.png",
																	},
																	style: {
																		fullWidthOnMobile: false,
																		align: "center",
																		lockedWidth: 300,
																		lockedHeight: 453,
																		maxHeight: "453px",
																		maxWidth: "300px",
																		width: "300px",
																		backgroundColor: "",
																		backgroundRepeat: "no-repeat",
																		backgroundPosition: "center center",
																		backgroundImage: "",
																		backgroundSize: "auto",
																		borderRadius: "0px",
																		borderLeftColor: "#121212",
																		borderLeftStyle: "solid",
																		borderLeftWidth: "0px",
																		borderBottomColor: "#121212",
																		borderBottomStyle: "solid",
																		borderBottomWidth: "0px",
																		borderRightColor: "#121212",
																		borderRightStyle: "solid",
																		borderRightWidth: "0px",
																		borderTopColor: "#121212",
																		borderTopStyle: "solid",
																		borderTopWidth: "0px",
																		marginLeft: "0px",
																		marginBottom: "0px",
																		marginRight: "0px",
																		marginTop: "0px",
																		paddingLeft: "0px",
																		paddingBottom: "0px",
																		paddingRight: "0px",
																		paddingTop: "0px",
																	},
																	customData: null,
																},
															],
															attrs: {
																hideOnMobile: false,
																hideOnDesktop: false,
															},
															style: {
																backgroundColor: "",
																backgroundRepeat: "no-repeat",
																backgroundPosition: "right top",
																backgroundImage: "",
																backgroundSize: "auto",
																borderRadius: "0px",
																borderLeftColor: "#121212",
																borderLeftStyle: "solid",
																borderLeftWidth: "0px",
																borderBottomColor: "#121212",
																borderBottomStyle: "solid",
																borderBottomWidth: "0px",
																borderRightColor: "#121212",
																borderRightStyle: "solid",
																borderRightWidth: "0px",
																borderTopColor: "#121212",
																borderTopStyle: "solid",
																borderTopWidth: "0px",
																marginLeft: "0px",
																marginBottom: "0px",
																marginRight: "0px",
																marginTop: "0px",
																paddingLeft: "0px",
																paddingBottom: "0px",
																paddingRight: "0px",
																paddingTop: "0px",
															},
															customData: {},
														},
													],
													attrs: {
														hideOnMobile: false,
														lock: false,
													},
													style: {
														width: "300px",
														backgroundColor: "",
														backgroundRepeat: "no-repeat",
														backgroundPosition: "center center",
														backgroundImage: "",
														backgroundSize: "auto",
													},
													customData: {},
												},
											],
											attrs: {
												hideOnMobile: false,
												hideOnDesktop: false,
												stacking: "right-on-top",
												spacerBefore: "0px",
												spacerBetween: "0px",
												spacerAfter: "0px",
												spacerBeforeMobile: "0px",
												spacerBetweenMobile: "10px",
												spacerAfterMobile: "0px",
											},
											style: {
												backgroundColor: "",
												backgroundRepeat: "no-repeat",
												backgroundPosition: "center center",
												backgroundImage: "",
												backgroundSize: "auto",
											},
											customData: {},
										},
									],
									attrs: {
										hideOnMobile: false,
										hideOnDesktop: false,
									},
									style: {
										backgroundColor: "",
										backgroundRepeat: "repeat",
										backgroundPosition: "center top",
										backgroundImage: "https://chamaileon-sdk.github.io/example-jsons/assets/backgrounds/1602506297978_bg_business_abstract.png",
										backgroundSize: "auto",
										borderRadius: "0px",
										borderLeftColor: "#121212",
										borderLeftStyle: "solid",
										borderLeftWidth: "0px",
										borderBottomColor: "#121212",
										borderBottomStyle: "solid",
										borderBottomWidth: "0px",
										borderRightColor: "#121212",
										borderRightStyle: "solid",
										borderRightWidth: "0px",
										borderTopColor: "#121212",
										borderTopStyle: "solid",
										borderTopWidth: "0px",
										marginLeft: "0px",
										marginBottom: "0px",
										marginRight: "0px",
										marginTop: "0px",
										paddingLeft: "0px",
										paddingBottom: "0px",
										paddingRight: "0px",
										paddingTop: "0px",
									},
									customData: {},
								},
							],
							attrs: {
								hideOnMobile: false,
								hideOnDesktop: false,
							},
							style: {
								backgroundColor: "",
								backgroundRepeat: "no-repeat",
								backgroundPosition: "center center",
								backgroundImage: "",
								backgroundSize: "auto",
								borderRadius: "0px",
								borderLeftColor: "#121212",
								borderLeftStyle: "solid",
								borderLeftWidth: "0px",
								borderBottomColor: "#121212",
								borderBottomStyle: "solid",
								borderBottomWidth: "0px",
								borderRightColor: "#121212",
								borderRightStyle: "solid",
								borderRightWidth: "0px",
								borderTopColor: "#121212",
								borderTopStyle: "solid",
								borderTopWidth: "0px",
								marginLeft: "0px",
								marginBottom: "0px",
								marginRight: "0px",
								marginTop: "0px",
								paddingLeft: "0px",
								paddingBottom: "0px",
								paddingRight: "0px",
								paddingTop: "0px",
							},
							customData: {},
						},
					],
					placeholder: [],
					attrs: {
						hideOnMobile: false,
						hideOnDesktop: false,
						lock: false,
						marker: "",
					},
					style: {
						backgroundColor: "transparent",
						backgroundRepeat: "no-repeat",
						backgroundPosition: "center center",
						backgroundImage: "",
						backgroundSize: "auto",
						contentBackgroundColor: {
							reference: "PrimaryColor",
							default: "#1762C5",
						},
						contentBackgroundRepeat: "no-repeat",
						contentBackgroundPosition: "center center",
						contentBackgroundImage: "",
						contentBackgroundSize: "auto",
						contentBorderRadius: "0px",
						contentBorderLeftColor: "#121212",
						contentBorderLeftStyle: "solid",
						contentBorderLeftWidth: "0px",
						contentBorderBottomColor: "#121212",
						contentBorderBottomStyle: "solid",
						contentBorderBottomWidth: "0px",
						contentBorderRightColor: "#121212",
						contentBorderRightStyle: "solid",
						contentBorderRightWidth: "0px",
						contentBorderTopColor: "#121212",
						contentBorderTopStyle: "solid",
						contentBorderTopWidth: "0px",
						contentMarginLeft: "0px",
						contentMarginBottom: "0px",
						contentMarginRight: "0px",
						contentMarginTop: "0px",
						contentPaddingLeft: "0px",
						contentPaddingBottom: "0px",
						contentPaddingRight: "0px",
						contentPaddingTop: "30px",
						contentWidth: 600,
						bodyWidth: 600,
					},
					customData: {},
				},
				{
					eid: "VNTQoTg1J",
					type: "fullwidth",
					children: [
						{
							eid: "ovOAW8EuqA",
							type: "image",
							attrs: {
								title: "",
								link: "",
								altText: "",
								src: "https://placehold.co/600x338/ededed/1762C5.png",
							},
							style: {
								fullWidthOnMobile: true,
								align: "left",
								lockedWidth: 150,
								lockedHeight: 150,
								maxHeight: "338px",
								maxWidth: "600px",
								width: "600px",
								backgroundColor: "",
								backgroundRepeat: "no-repeat",
								backgroundPosition: "center center",
								backgroundImage: "",
								backgroundSize: "auto",
								borderRadius: "0px",
								borderLeftColor: "#121212",
								borderLeftStyle: "solid",
								borderLeftWidth: "0px",
								borderBottomColor: "#121212",
								borderBottomStyle: "solid",
								borderBottomWidth: "0px",
								borderRightColor: "#121212",
								borderRightStyle: "solid",
								borderRightWidth: "0px",
								borderTopColor: "#121212",
								borderTopStyle: "solid",
								borderTopWidth: "0px",
								marginLeft: "0px",
								marginBottom: "0px",
								marginRight: "0px",
								marginTop: "0px",
								paddingLeft: "0px",
								paddingBottom: "0px",
								paddingRight: "0px",
								paddingTop: "0px",
							},
							customData: null,
						},
					],
					placeholder: [],
					attrs: {
						hideOnMobile: false,
						hideOnDesktop: false,
						lock: false,
						marker: "",
					},
					style: {
						backgroundColor: "",
						backgroundRepeat: "no-repeat",
						backgroundPosition: "center center",
						backgroundImage: "",
						backgroundSize: "auto",
						contentBackgroundColor: "",
						contentBackgroundRepeat: "no-repeat",
						contentBackgroundPosition: "center center",
						contentBackgroundImage: "",
						contentBackgroundSize: "auto",
						contentBorderRadius: "0px",
						contentBorderLeftColor: "#121212",
						contentBorderLeftStyle: "solid",
						contentBorderLeftWidth: "0px",
						contentBorderBottomColor: "#121212",
						contentBorderBottomStyle: "solid",
						contentBorderBottomWidth: "0px",
						contentBorderRightColor: "#121212",
						contentBorderRightStyle: "solid",
						contentBorderRightWidth: "0px",
						contentBorderTopColor: "#121212",
						contentBorderTopStyle: "solid",
						contentBorderTopWidth: "0px",
						contentMarginLeft: "0px",
						contentMarginBottom: "0px",
						contentMarginRight: "0px",
						contentMarginTop: "0px",
						contentPaddingLeft: "0px",
						contentPaddingBottom: "0px",
						contentPaddingRight: "0px",
						contentPaddingTop: "0px",
						contentWidth: 600,
						bodyWidth: 600,
					},
					customData: {},
				},
				{
					eid: "soCCJ5Ojg",
					type: "fullwidth",
					children: [
						{
							eid: "gOWjMp2wWQ",
							type: "box",
							children: [
								{
									eid: "s6yq9jz8mN",
									type: "box",
									children: [
										{
											eid: "Cgd7WxOFtg",
											type: "box",
											children: [
												{
													eid: "BO2hU5VzcI",
													type: "text",
													attrs: {
														text: "<p><strong>Welcome to my Customers!</strong></p>\n",
													},
													style: {
														backgroundColor: "transparent",
														backgroundRepeat: "no-repeat",
														backgroundPosition: "center center",
														backgroundImage: "",
														backgroundSize: "auto",
														paddingLeft: "20px",
														paddingBottom: "0px",
														paddingRight: "20px",
														paddingTop: "5px",
														paragraphLineHeight: "40px",
														paragraphLetterSpacing: "normal",
														paragraphColor: "#FFFFFF",
														paragraphFontSize: "35px",
														paragraphFontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif",
														linkTextDecoration: "underline",
														linkColor: "#00c0e7",
														h3LineHeight: "27px",
														h3Color: "#000000",
														h3FontSize: "22px",
														h3FontFamily: "Georgia, Times, Times New Roman, serif",
														h3LetterSpacing: "normal",
														h2LineHeight: "34px",
														h2Color: "#000000",
														h2FontSize: "26px",
														h2FontFamily: "Georgia, Times, Times New Roman, serif",
														h2LetterSpacing: "normal",
														h1LineHeight: "40px",
														h1Color: "#000000",
														h1FontSize: "33px",
														h1FontFamily: "Georgia, Times, Times New Roman, serif",
														h1LetterSpacing: "normal",
														h6: {},
														h5: {},
														h4: {},
													},
													customData: null,
												},
											],
											attrs: {
												hideOnMobile: false,
												hideOnDesktop: false,
											},
											style: {
												backgroundColor: "",
												backgroundRepeat: "no-repeat",
												backgroundPosition: "center center",
												backgroundImage: "",
												backgroundSize: "auto",
												borderRadius: "0px",
												borderLeftColor: "#121212",
												borderLeftStyle: "solid",
												borderLeftWidth: "0px",
												borderBottomColor: "#121212",
												borderBottomStyle: "solid",
												borderBottomWidth: "0px",
												borderRightColor: "#121212",
												borderRightStyle: "solid",
												borderRightWidth: "0px",
												borderTopColor: "#121212",
												borderTopStyle: "solid",
												borderTopWidth: "0px",
												marginLeft: "0px",
												marginBottom: "0px",
												marginRight: "0px",
												marginTop: "0px",
												paddingLeft: "0px",
												paddingBottom: "0px",
												paddingRight: "0px",
												paddingTop: "0px",
											},
											customData: {},
										},
										{
											eid: "G3i_ontanE",
											type: "text",
											attrs: {
												text: "<p>10-15. Joey Barch</p>\n",
											},
											style: {
												backgroundColor: "",
												backgroundRepeat: "no-repeat",
												backgroundPosition: "center center",
												backgroundImage: "",
												backgroundSize: "auto",
												paddingLeft: "20px",
												paddingBottom: "15px",
												paddingRight: "20px",
												paddingTop: "5px",
												paragraphLineHeight: "25px",
												paragraphLetterSpacing: "normal",
												paragraphColor: "#B6D2F6",
												paragraphFontSize: "14px",
												paragraphFontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif",
												linkTextDecoration: "underline",
												linkColor: {
													reference: "SecondaryColor",
													default: "#00c0e7",
												},
												h3LineHeight: "27px",
												h3Color: "#000000",
												h3FontSize: "22px",
												h3FontFamily: "Georgia, Times, Times New Roman, serif",
												h3LetterSpacing: "normal",
												h2LineHeight: "34px",
												h2Color: "#000000",
												h2FontSize: "26px",
												h2FontFamily: "Georgia, Times, Times New Roman, serif",
												h2LetterSpacing: "normal",
												h1LineHeight: "40px",
												h1Color: "#000000",
												h1FontSize: "33px",
												h1FontFamily: "Georgia, Times, Times New Roman, serif",
												h1LetterSpacing: "normal",
												h6: {},
												h5: {},
												h4: {},
											},
											customData: null,
										},
										{
											eid: "TuAiS7jSBI",
											type: "text",
											attrs: {
												text: "<p>Sed et lacus volutpat, consectetur erat vel, aliquet mauris. Praesent nisi elit, molestie sit amet ante ut, consectetur condimentum elit. Aliquam erat volutpat. Aenean nec congue est. Aliquam erat volutpat. Ut in feugiat est. Quisque libero tellus, volutpat non dapibus vitae, feugiat quis nisl.</p>\n",
											},
											style: {
												backgroundColor: "",
												backgroundRepeat: "no-repeat",
												backgroundPosition: "center center",
												backgroundImage: "",
												backgroundSize: "auto",
												paddingLeft: "20px",
												paddingBottom: "10px",
												paddingRight: "20px",
												paddingTop: "10px",
												paragraphLineHeight: "25px",
												paragraphLetterSpacing: "normal",
												paragraphColor: "#EDF4FD",
												paragraphFontSize: "16px",
												paragraphFontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif",
												linkTextDecoration: "underline",
												linkColor: "#00c0e7",
												h3LineHeight: "27px",
												h3Color: "#000000",
												h3FontSize: "22px",
												h3FontFamily: "Georgia, Times, Times New Roman, serif",
												h3LetterSpacing: "normal",
												h2LineHeight: "34px",
												h2Color: "#000000",
												h2FontSize: "26px",
												h2FontFamily: "Georgia, Times, Times New Roman, serif",
												h2LetterSpacing: "normal",
												h1LineHeight: "40px",
												h1Color: "#000000",
												h1FontSize: "33px",
												h1FontFamily: "Georgia, Times, Times New Roman, serif",
												h1LetterSpacing: "normal",
												h6: {},
												h5: {},
												h4: {},
											},
											customData: null,
										},
										{
											eid: "rn5lr5NNrN",
											type: "button",
											attrs: {
												title: "",
												text: "<p>Read Now</p>\n",
												href: "",
											},
											style: {
												lineHeight: "24px",
												color: "#ffffff",
												fontSize: "17px",
												fontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif",
												letterSpacing: "normal",
												backgroundColor: {
													reference: "SecondaryColor",
													default: "#5C9AEB",
												},
												backgroundRepeat: "no-repeat",
												backgroundPosition: "center center",
												backgroundImage: "",
												backgroundSize: "auto",
												borderRadius: "5px",
												borderLeftColor: "#121212",
												borderLeftStyle: "solid",
												borderLeftWidth: "0px",
												borderBottomColor: "#121212",
												borderBottomStyle: "solid",
												borderBottomWidth: "0px",
												borderRightColor: "#121212",
												borderRightStyle: "solid",
												borderRightWidth: "0px",
												borderTopColor: "#121212",
												borderTopStyle: "solid",
												borderTopWidth: "0px",
												marginLeft: "20px",
												marginBottom: "20px",
												marginRight: "20px",
												marginTop: "20px",
												paddingLeft: "25px",
												paddingBottom: "9px",
												paddingRight: "25px",
												paddingTop: "9px",
												hoverBackgroundColor: "",
												sizeType: "FIT_TO_TEXT",
												fullWidthOnMobile: true,
												align: "left",
											},
											customData: null,
										},
									],
									attrs: {
										hideOnMobile: false,
										hideOnDesktop: false,
									},
									style: {
										backgroundColor: "transparent",
										backgroundRepeat: "repeat",
										backgroundPosition: "center top",
										backgroundImage: "https://chamaileon-sdk.github.io/example-jsons/assets/backgrounds/1602506297978_bg_business_abstract.png",
										backgroundSize: "auto",
										borderRadius: "0px",
										borderLeftColor: "#121212",
										borderLeftStyle: "solid",
										borderLeftWidth: "0px",
										borderBottomColor: "#121212",
										borderBottomStyle: "solid",
										borderBottomWidth: "0px",
										borderRightColor: "#121212",
										borderRightStyle: "solid",
										borderRightWidth: "0px",
										borderTopColor: "#121212",
										borderTopStyle: "solid",
										borderTopWidth: "0px",
										marginLeft: "0px",
										marginBottom: "0px",
										marginRight: "0px",
										marginTop: "0px",
										paddingLeft: "0px",
										paddingBottom: "30px",
										paddingRight: "0px",
										paddingTop: "30px",
									},
									customData: {},
								},
							],
							attrs: {
								hideOnMobile: false,
								hideOnDesktop: false,
							},
							style: {
								backgroundColor: {
									reference: "PrimaryColor",
									default: "#1762C5",
								},
								backgroundRepeat: "no-repeat",
								backgroundPosition: "center center",
								backgroundImage: "",
								backgroundSize: "auto",
								borderRadius: "0px",
								borderLeftColor: "#121212",
								borderLeftStyle: "solid",
								borderLeftWidth: "0px",
								borderBottomColor: "#121212",
								borderBottomStyle: "solid",
								borderBottomWidth: "0px",
								borderRightColor: "#121212",
								borderRightStyle: "solid",
								borderRightWidth: "0px",
								borderTopColor: "#121212",
								borderTopStyle: "solid",
								borderTopWidth: "0px",
								marginLeft: "0px",
								marginBottom: "0px",
								marginRight: "0px",
								marginTop: "0px",
								paddingLeft: "0px",
								paddingBottom: "0px",
								paddingRight: "0px",
								paddingTop: "0px",
							},
							customData: {},
						},
					],
					placeholder: [],
					attrs: {
						hideOnMobile: false,
						hideOnDesktop: false,
						lock: false,
						marker: "",
					},
					style: {
						backgroundColor: "",
						backgroundRepeat: "no-repeat",
						backgroundPosition: "center center",
						backgroundImage: "",
						backgroundSize: "auto",
						contentBackgroundColor: "",
						contentBackgroundRepeat: "no-repeat",
						contentBackgroundPosition: "center center",
						contentBackgroundImage: "",
						contentBackgroundSize: "auto",
						contentBorderRadius: "0px",
						contentBorderLeftColor: "#121212",
						contentBorderLeftStyle: "solid",
						contentBorderLeftWidth: "0px",
						contentBorderBottomColor: "#121212",
						contentBorderBottomStyle: "solid",
						contentBorderBottomWidth: "0px",
						contentBorderRightColor: "#121212",
						contentBorderRightStyle: "solid",
						contentBorderRightWidth: "0px",
						contentBorderTopColor: "#121212",
						contentBorderTopStyle: "solid",
						contentBorderTopWidth: "0px",
						contentMarginLeft: "0px",
						contentMarginBottom: "0px",
						contentMarginRight: "0px",
						contentMarginTop: "0px",
						contentPaddingLeft: "0px",
						contentPaddingBottom: "0px",
						contentPaddingRight: "0px",
						contentPaddingTop: "0px",
						contentWidth: 600,
						bodyWidth: 600,
					},
					customData: {},
				},
				{
					eid: "59PPr8w73",
					type: "fullwidth",
					children: [
						{
							eid: "VIiDfNhY6i",
							type: "box",
							children: [
								{
									eid: "U_Nn_dyvt",
									type: "box",
									children: [
										{
											eid: "UhlM1UHNLW",
											type: "text",
											attrs: {
												text: "<p style=\"text-align: center;\"><strong>Professional</strong></p>\n",
											},
											style: {
												backgroundColor: "",
												backgroundRepeat: "no-repeat",
												backgroundPosition: "center center",
												backgroundImage: "",
												backgroundSize: "auto",
												paddingLeft: "10px",
												paddingBottom: "0px",
												paddingRight: "10px",
												paddingTop: "10px",
												paragraphLineHeight: "40px",
												paragraphLetterSpacing: "normal",
												paragraphColor: {
													reference: "PrimaryColor",
													default: "#165BB4",
												},
												paragraphFontSize: "35px",
												paragraphFontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif",
												linkTextDecoration: "underline",
												linkColor: "#00c0e7",
												h3LineHeight: "27px",
												h3Color: "#000000",
												h3FontSize: "22px",
												h3FontFamily: "Georgia, Times, Times New Roman, serif",
												h3LetterSpacing: "normal",
												h2LineHeight: "34px",
												h2Color: "#000000",
												h2FontSize: "26px",
												h2FontFamily: "Georgia, Times, Times New Roman, serif",
												h2LetterSpacing: "normal",
												h1LineHeight: "40px",
												h1Color: "#000000",
												h1FontSize: "33px",
												h1FontFamily: "Georgia, Times, Times New Roman, serif",
												h1LetterSpacing: "normal",
												h6: {},
												h5: {},
												h4: {},
											},
											customData: null,
										},
										{
											eid: "d-CZCx-OWv",
											type: "text",
											attrs: {
												text: "<p style=\"text-align: center;\">STRATEGY TEAM</p>\n",
											},
											style: {
												backgroundColor: "",
												backgroundRepeat: "no-repeat",
												backgroundPosition: "center center",
												backgroundImage: "",
												backgroundSize: "auto",
												paddingLeft: "10px",
												paddingBottom: "15px",
												paddingRight: "10px",
												paddingTop: "5px",
												paragraphLineHeight: "20px",
												paragraphLetterSpacing: "normal",
												paragraphColor: {
													reference: "SecondaryColor",
													default: "#5C9AEB",
												},
												paragraphFontSize: "15px",
												paragraphFontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif",
												linkTextDecoration: "underline",
												linkColor: {
													reference: "SecondaryColor",
													default: "#00c0e7",
												},
												h3LineHeight: "27px",
												h3Color: "#000000",
												h3FontSize: "22px",
												h3FontFamily: "Georgia, Times, Times New Roman, serif",
												h3LetterSpacing: "normal",
												h2LineHeight: "34px",
												h2Color: "#000000",
												h2FontSize: "26px",
												h2FontFamily: "Georgia, Times, Times New Roman, serif",
												h2LetterSpacing: "normal",
												h1LineHeight: "40px",
												h1Color: "#000000",
												h1FontSize: "33px",
												h1FontFamily: "Georgia, Times, Times New Roman, serif",
												h1LetterSpacing: "normal",
												h6: {},
												h5: {},
												h4: {},
											},
											customData: null,
										},
										{
											eid: "-5EX_YNIcx",
											type: "text",
											attrs: {
												text: "<p>Fusce maximus nunc ut quam aliquet, cursus tempus justo tincidunt. Vivamus quis magna molestie, pellentesque tellus ac, efficitur nibh,&nbsp;cursus tempus justo tincidunt.</p>\n",
											},
											style: {
												backgroundColor: "",
												backgroundRepeat: "no-repeat",
												backgroundPosition: "center center",
												backgroundImage: "",
												backgroundSize: "auto",
												paddingLeft: "10px",
												paddingBottom: "10px",
												paddingRight: "10px",
												paddingTop: "10px",
												paragraphLineHeight: "23px",
												paragraphLetterSpacing: "normal",
												paragraphColor: {
													reference: "PrimaryColor",
													default: "#165BB4",
												},
												paragraphFontSize: "15px",
												paragraphFontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif",
												linkTextDecoration: "underline",
												linkColor: "#00c0e7",
												h3LineHeight: "27px",
												h3Color: "#000000",
												h3FontSize: "22px",
												h3FontFamily: "Georgia, Times, Times New Roman, serif",
												h3LetterSpacing: "normal",
												h2LineHeight: "34px",
												h2Color: "#000000",
												h2FontSize: "26px",
												h2FontFamily: "Georgia, Times, Times New Roman, serif",
												h2LetterSpacing: "normal",
												h1LineHeight: "40px",
												h1Color: "#000000",
												h1FontSize: "33px",
												h1FontFamily: "Georgia, Times, Times New Roman, serif",
												h1LetterSpacing: "normal",
												h6: {},
												h5: {},
												h4: {},
											},
											customData: null,
										},
										{
											eid: "GAOcGJo9u",
											type: "button",
											attrs: {
												title: "",
												text: "<p>Shop Now</p>\n",
												href: "",
											},
											style: {
												lineHeight: "24px",
												color: "#ffffff",
												fontSize: "17px",
												fontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif",
												letterSpacing: "normal",
												backgroundColor: {
													reference: "PrimaryColor",
													default: "#165BB4",
												},
												backgroundRepeat: "no-repeat",
												backgroundPosition: "center center",
												backgroundImage: "",
												backgroundSize: "auto",
												borderRadius: "5px",
												borderLeftColor: "#121212",
												borderLeftStyle: "solid",
												borderLeftWidth: "0px",
												borderBottomColor: "#121212",
												borderBottomStyle: "solid",
												borderBottomWidth: "0px",
												borderRightColor: "#121212",
												borderRightStyle: "solid",
												borderRightWidth: "0px",
												borderTopColor: "#121212",
												borderTopStyle: "solid",
												borderTopWidth: "0px",
												marginLeft: "10px",
												marginBottom: "20px",
												marginRight: "10px",
												marginTop: "20px",
												paddingLeft: "25px",
												paddingBottom: "9px",
												paddingRight: "25px",
												paddingTop: "9px",
												hoverBackgroundColor: "",
												sizeType: "FIT_TO_TEXT",
												fullWidthOnMobile: true,
												align: "center",
											},
											customData: null,
										},
									],
									attrs: {
										hideOnMobile: false,
										hideOnDesktop: false,
									},
									style: {
										backgroundColor: "",
										backgroundRepeat: "repeat",
										backgroundPosition: "center top",
										backgroundImage: "https://chamaileon-sdk.github.io/example-jsons/assets/backgrounds/1602506297978_bg_business_abstract.png",
										backgroundSize: "auto",
										borderRadius: "0px",
										borderLeftColor: "#121212",
										borderLeftStyle: "solid",
										borderLeftWidth: "0px",
										borderBottomColor: "#121212",
										borderBottomStyle: "solid",
										borderBottomWidth: "0px",
										borderRightColor: "#121212",
										borderRightStyle: "solid",
										borderRightWidth: "0px",
										borderTopColor: "#121212",
										borderTopStyle: "solid",
										borderTopWidth: "0px",
										marginLeft: "0px",
										marginBottom: "0px",
										marginRight: "0px",
										marginTop: "0px",
										paddingLeft: "10px",
										paddingBottom: "30px",
										paddingRight: "10px",
										paddingTop: "30px",
									},
									customData: {},
								},
							],
							attrs: {
								hideOnMobile: false,
								hideOnDesktop: false,
							},
							style: {
								backgroundColor: "#EDF4FD",
								backgroundRepeat: "no-repeat",
								backgroundPosition: "center center",
								backgroundImage: "",
								backgroundSize: "auto",
								borderRadius: "0px",
								borderLeftColor: "#121212",
								borderLeftStyle: "solid",
								borderLeftWidth: "0px",
								borderBottomColor: "#121212",
								borderBottomStyle: "solid",
								borderBottomWidth: "0px",
								borderRightColor: "#121212",
								borderRightStyle: "solid",
								borderRightWidth: "0px",
								borderTopColor: "#121212",
								borderTopStyle: "solid",
								borderTopWidth: "0px",
								marginLeft: "0px",
								marginBottom: "0px",
								marginRight: "0px",
								marginTop: "0px",
								paddingLeft: "0px",
								paddingBottom: "0px",
								paddingRight: "0px",
								paddingTop: "0px",
							},
							customData: {},
						},
					],
					placeholder: [],
					attrs: {
						hideOnMobile: false,
						hideOnDesktop: false,
						lock: false,
						marker: "",
					},
					style: {
						backgroundColor: "",
						backgroundRepeat: "no-repeat",
						backgroundPosition: "center center",
						backgroundImage: "",
						backgroundSize: "auto",
						contentBackgroundColor: "",
						contentBackgroundRepeat: "no-repeat",
						contentBackgroundPosition: "center center",
						contentBackgroundImage: "",
						contentBackgroundSize: "auto",
						contentBorderRadius: "0px",
						contentBorderLeftColor: "#121212",
						contentBorderLeftStyle: "solid",
						contentBorderLeftWidth: "0px",
						contentBorderBottomColor: "#121212",
						contentBorderBottomStyle: "solid",
						contentBorderBottomWidth: "0px",
						contentBorderRightColor: "#121212",
						contentBorderRightStyle: "solid",
						contentBorderRightWidth: "0px",
						contentBorderTopColor: "#121212",
						contentBorderTopStyle: "solid",
						contentBorderTopWidth: "0px",
						contentMarginLeft: "0px",
						contentMarginBottom: "0px",
						contentMarginRight: "0px",
						contentMarginTop: "0px",
						contentPaddingLeft: "0px",
						contentPaddingBottom: "0px",
						contentPaddingRight: "0px",
						contentPaddingTop: "0px",
						contentWidth: 600,
						bodyWidth: 600,
					},
					customData: {},
				},
				{
					eid: "QwLXd7U6a",
					type: "fullwidth",
					children: [
						{
							eid: "2O4g0z1rZ-",
							type: "image",
							attrs: {
								title: "",
								link: "",
								altText: "",
								src: "https://placehold.co/600x338/a1a1a1/1762C5.png",
							},
							style: {
								fullWidthOnMobile: true,
								align: "left",
								lockedWidth: 150,
								lockedHeight: 150,
								maxHeight: "338px",
								maxWidth: "600px",
								width: "600px",
								backgroundColor: "",
								backgroundRepeat: "no-repeat",
								backgroundPosition: "center center",
								backgroundImage: "",
								backgroundSize: "auto",
								borderRadius: "0px",
								borderLeftColor: "#121212",
								borderLeftStyle: "solid",
								borderLeftWidth: "0px",
								borderBottomColor: "#121212",
								borderBottomStyle: "solid",
								borderBottomWidth: "0px",
								borderRightColor: "#121212",
								borderRightStyle: "solid",
								borderRightWidth: "0px",
								borderTopColor: "#121212",
								borderTopStyle: "solid",
								borderTopWidth: "0px",
								marginLeft: "0px",
								marginBottom: "0px",
								marginRight: "0px",
								marginTop: "0px",
								paddingLeft: "0px",
								paddingBottom: "0px",
								paddingRight: "0px",
								paddingTop: "0px",
							},
							customData: null,
						},
					],
					placeholder: [],
					attrs: {
						hideOnMobile: false,
						hideOnDesktop: false,
						lock: false,
						marker: "",
					},
					style: {
						backgroundColor: "",
						backgroundRepeat: "no-repeat",
						backgroundPosition: "center center",
						backgroundImage: "",
						backgroundSize: "auto",
						contentBackgroundColor: "",
						contentBackgroundRepeat: "no-repeat",
						contentBackgroundPosition: "center center",
						contentBackgroundImage: "",
						contentBackgroundSize: "auto",
						contentBorderRadius: "0px",
						contentBorderLeftColor: "#121212",
						contentBorderLeftStyle: "solid",
						contentBorderLeftWidth: "0px",
						contentBorderBottomColor: "#121212",
						contentBorderBottomStyle: "solid",
						contentBorderBottomWidth: "0px",
						contentBorderRightColor: "#121212",
						contentBorderRightStyle: "solid",
						contentBorderRightWidth: "0px",
						contentBorderTopColor: "#121212",
						contentBorderTopStyle: "solid",
						contentBorderTopWidth: "0px",
						contentMarginLeft: "0px",
						contentMarginBottom: "0px",
						contentMarginRight: "0px",
						contentMarginTop: "0px",
						contentPaddingLeft: "0px",
						contentPaddingBottom: "0px",
						contentPaddingRight: "0px",
						contentPaddingTop: "0px",
						contentWidth: 600,
						bodyWidth: 600,
					},
					customData: {},
				},
				{
					eid: "bHzIV_Sfc",
					type: "fullwidth",
					children: [
						{
							eid: "4ntLwmG08h",
							type: "multicolumn",
							children: [
								{
									eid: "XfXMSGy0_l",
									type: "column",
									children: [
										{
											eid: "ADA248pD8",
											type: "box",
											children: [
												{
													eid: "ahJjh4-AS",
													type: "text",
													attrs: {
														text: "<p><strong>Our Team</strong></p>\n",
													},
													style: {
														backgroundColor: "",
														backgroundRepeat: "no-repeat",
														backgroundPosition: "center center",
														backgroundImage: "",
														backgroundSize: "auto",
														paddingLeft: "10px",
														paddingBottom: "0px",
														paddingRight: "10px",
														paddingTop: "5px",
														paragraphLineHeight: "35px",
														paragraphLetterSpacing: "normal",
														paragraphColor: "#FFFFFF",
														paragraphFontSize: "35px",
														paragraphFontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif",
														linkTextDecoration: "underline",
														linkColor: "#FFFFFF",
														h3LineHeight: "27px",
														h3Color: "#000000",
														h3FontSize: "22px",
														h3FontFamily: "Georgia, Times, Times New Roman, serif",
														h3LetterSpacing: "normal",
														h2LineHeight: "34px",
														h2Color: "#000000",
														h2FontSize: "26px",
														h2FontFamily: "Georgia, Times, Times New Roman, serif",
														h2LetterSpacing: "normal",
														h1LineHeight: "40px",
														h1Color: "#000000",
														h1FontSize: "33px",
														h1FontFamily: "Georgia, Times, Times New Roman, serif",
														h1LetterSpacing: "normal",
														h6: {},
														h5: {},
														h4: {},
													},
													customData: null,
												},
												{
													eid: "bl7UAtOYe",
													type: "text",
													attrs: {
														text: "<p>MEET WITH</p>\n",
													},
													style: {
														backgroundColor: "",
														backgroundRepeat: "no-repeat",
														backgroundPosition: "center center",
														backgroundImage: "",
														backgroundSize: "auto",
														paddingLeft: "10px",
														paddingBottom: "15px",
														paddingRight: "10px",
														paddingTop: "5px",
														paragraphLineHeight: "20px",
														paragraphLetterSpacing: "normal",
														paragraphColor: {
															reference: "PrimaryColor",
															default: "#165BB4",
														},
														paragraphFontSize: "15px",
														paragraphFontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif",
														linkTextDecoration: "underline",
														linkColor: "#00c0e7",
														h3LineHeight: "27px",
														h3Color: "#000000",
														h3FontSize: "22px",
														h3FontFamily: "Georgia, Times, Times New Roman, serif",
														h3LetterSpacing: "normal",
														h2LineHeight: "34px",
														h2Color: "#000000",
														h2FontSize: "26px",
														h2FontFamily: "Georgia, Times, Times New Roman, serif",
														h2LetterSpacing: "normal",
														h1LineHeight: "40px",
														h1Color: "#000000",
														h1FontSize: "33px",
														h1FontFamily: "Georgia, Times, Times New Roman, serif",
														h1LetterSpacing: "normal",
														h6: {},
														h5: {},
														h4: {},
													},
													customData: null,
												},
												{
													eid: "9c0_LzTtC",
													type: "text",
													attrs: {
														text: "<p><strong>Vivamus accumsan erat id tortor ornare euismod.</strong></p>\n\n<p>Nullam enim libero. Cras non magna sit amet massa aliquam suscipit.</p>\n",
													},
													style: {
														backgroundColor: "",
														backgroundRepeat: "no-repeat",
														backgroundPosition: "center center",
														backgroundImage: "",
														backgroundSize: "auto",
														paddingLeft: "10px",
														paddingBottom: "5px",
														paddingRight: "10px",
														paddingTop: "10px",
														paragraphLineHeight: "25px",
														paragraphLetterSpacing: "normal",
														paragraphColor: "#FFFFFF",
														paragraphFontSize: "16px",
														paragraphFontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif",
														linkTextDecoration: "underline",
														linkColor: "#00c0e7",
														h3LineHeight: "27px",
														h3Color: "#000000",
														h3FontSize: "22px",
														h3FontFamily: "Georgia, Times, Times New Roman, serif",
														h3LetterSpacing: "normal",
														h2LineHeight: "34px",
														h2Color: "#000000",
														h2FontSize: "26px",
														h2FontFamily: "Georgia, Times, Times New Roman, serif",
														h2LetterSpacing: "normal",
														h1LineHeight: "40px",
														h1Color: "#000000",
														h1FontSize: "33px",
														h1FontFamily: "Georgia, Times, Times New Roman, serif",
														h1LetterSpacing: "normal",
														h6: {},
														h5: {},
														h4: {},
													},
													customData: null,
												},
												{
													eid: "Cy0EjuLkf",
													type: "text",
													attrs: {
														text: "<p>Aenean ac finibus dui, non eleifend ligula. Nulla facilisi. Aligue condim. <strong>Sed suscipit metus ligula!</strong></p>\n",
													},
													style: {
														backgroundColor: "",
														backgroundRepeat: "no-repeat",
														backgroundPosition: "center center",
														backgroundImage: "",
														backgroundSize: "auto",
														paddingLeft: "10px",
														paddingBottom: "10px",
														paddingRight: "10px",
														paddingTop: "10px",
														paragraphLineHeight: "25px",
														paragraphLetterSpacing: "normal",
														paragraphColor: "#FFFFFF",
														paragraphFontSize: "16px",
														paragraphFontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif",
														linkTextDecoration: "underline",
														linkColor: "#00c0e7",
														h3LineHeight: "27px",
														h3Color: "#000000",
														h3FontSize: "22px",
														h3FontFamily: "Georgia, Times, Times New Roman, serif",
														h3LetterSpacing: "normal",
														h2LineHeight: "34px",
														h2Color: "#000000",
														h2FontSize: "26px",
														h2FontFamily: "Georgia, Times, Times New Roman, serif",
														h2LetterSpacing: "normal",
														h1LineHeight: "40px",
														h1Color: "#000000",
														h1FontSize: "33px",
														h1FontFamily: "Georgia, Times, Times New Roman, serif",
														h1LetterSpacing: "normal",
														h6: {},
														h5: {},
														h4: {},
													},
													customData: null,
												},
												{
													eid: "v0lUz7EZ7",
													type: "button",
													attrs: {
														title: "",
														text: "<p>Shop Now</p>\n",
														href: "",
													},
													style: {
														lineHeight: "24px",
														color: "#ffffff",
														fontSize: "17px",
														fontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif",
														letterSpacing: "normal",
														backgroundColor: {
															reference: "PrimaryColor",
															default: "#165BB4",
														},
														backgroundRepeat: "no-repeat",
														backgroundPosition: "center center",
														backgroundImage: "",
														backgroundSize: "auto",
														borderRadius: "5px",
														borderLeftColor: "#121212",
														borderLeftStyle: "solid",
														borderLeftWidth: "0px",
														borderBottomColor: "#121212",
														borderBottomStyle: "solid",
														borderBottomWidth: "0px",
														borderRightColor: "#121212",
														borderRightStyle: "solid",
														borderRightWidth: "0px",
														borderTopColor: "#121212",
														borderTopStyle: "solid",
														borderTopWidth: "0px",
														marginLeft: "10px",
														marginBottom: "20px",
														marginRight: "10px",
														marginTop: "20px",
														paddingLeft: "25px",
														paddingBottom: "9px",
														paddingRight: "25px",
														paddingTop: "9px",
														hoverBackgroundColor: "",
														sizeType: "FIT_TO_TEXT",
														fullWidthOnMobile: true,
														align: "left",
													},
													customData: null,
												},
											],
											attrs: {
												hideOnMobile: false,
												hideOnDesktop: false,
											},
											style: {
												backgroundColor: "",
												backgroundRepeat: "no-repeat",
												backgroundPosition: "center center",
												backgroundImage: "",
												backgroundSize: "auto",
												borderRadius: "0px",
												borderLeftColor: "#121212",
												borderLeftStyle: "solid",
												borderLeftWidth: "0px",
												borderBottomColor: "#121212",
												borderBottomStyle: "solid",
												borderBottomWidth: "0px",
												borderRightColor: "#121212",
												borderRightStyle: "solid",
												borderRightWidth: "0px",
												borderTopColor: "#121212",
												borderTopStyle: "solid",
												borderTopWidth: "0px",
												marginLeft: "0px",
												marginBottom: "0px",
												marginRight: "0px",
												marginTop: "0px",
												paddingLeft: "10px",
												paddingBottom: "0px",
												paddingRight: "10px",
												paddingTop: "30px",
											},
											customData: {},
										},
									],
									attrs: {
										hideOnMobile: false,
										lock: false,
									},
									style: {
										width: "300px",
										backgroundColor: "transparent",
										backgroundRepeat: "no-repeat",
										backgroundPosition: "center center",
										backgroundImage: "",
										backgroundSize: "auto",
									},
									customData: {},
								},
								{
									eid: "WLdDd6XuQz",
									type: "column",
									children: [
										{
											eid: "hT8hhX4Ho",
											type: "image",
											attrs: {
												title: "",
												link: "",
												altText: "",
												src: "https://placehold.co/300x453/ededed/5C9AEB.png",
											},
											style: {
												fullWidthOnMobile: false,
												align: "right",
												lockedWidth: null,
												lockedHeight: null,
												maxHeight: "453px",
												maxWidth: "300px",
												width: "300px",
												backgroundColor: "",
												backgroundRepeat: "no-repeat",
												backgroundPosition: "center center",
												backgroundImage: "",
												backgroundSize: "auto",
												borderRadius: "0px",
												borderLeftColor: "#121212",
												borderLeftStyle: "solid",
												borderLeftWidth: "0px",
												borderBottomColor: "#121212",
												borderBottomStyle: "solid",
												borderBottomWidth: "0px",
												borderRightColor: "#121212",
												borderRightStyle: "solid",
												borderRightWidth: "0px",
												borderTopColor: "#121212",
												borderTopStyle: "solid",
												borderTopWidth: "0px",
												marginLeft: "0px",
												marginBottom: "0px",
												marginRight: "0px",
												marginTop: "0px",
												paddingLeft: "0px",
												paddingBottom: "0px",
												paddingRight: "0px",
												paddingTop: "0px",
											},
											customData: null,
										},
									],
									attrs: {
										hideOnMobile: false,
										lock: false,
									},
									style: {
										width: "300px",
										backgroundColor: "",
										backgroundRepeat: "no-repeat",
										backgroundPosition: "center center",
										backgroundImage: "",
										backgroundSize: "auto",
									},
									customData: {},
								},
							],
							attrs: {
								hideOnMobile: false,
								hideOnDesktop: false,
								stacking: "left-on-top",
								spacerBefore: "0px",
								spacerBetween: "0px",
								spacerAfter: "0px",
								spacerBeforeMobile: "0px",
								spacerBetweenMobile: "0px",
								spacerAfterMobile: "0px",
							},
							style: {
								backgroundColor: "",
								backgroundRepeat: "no-repeat",
								backgroundPosition: "center center",
								backgroundImage: "",
								backgroundSize: "auto",
							},
							customData: {},
						},
					],
					placeholder: [],
					attrs: {
						hideOnMobile: false,
						hideOnDesktop: false,
						lock: false,
						marker: "",
					},
					style: {
						backgroundColor: "",
						backgroundRepeat: "no-repeat",
						backgroundPosition: "center center",
						backgroundImage: "",
						backgroundSize: "auto",
						contentBackgroundColor: {
							reference: "SecondaryColor",
							default: "#5C9AEB",
						},
						contentBackgroundRepeat: "no-repeat",
						contentBackgroundPosition: "center center",
						contentBackgroundImage: "",
						contentBackgroundSize: "auto",
						contentBorderRadius: "0px",
						contentBorderLeftColor: "#121212",
						contentBorderLeftStyle: "solid",
						contentBorderLeftWidth: "0px",
						contentBorderBottomColor: "#121212",
						contentBorderBottomStyle: "solid",
						contentBorderBottomWidth: "0px",
						contentBorderRightColor: "#121212",
						contentBorderRightStyle: "solid",
						contentBorderRightWidth: "0px",
						contentBorderTopColor: "#121212",
						contentBorderTopStyle: "solid",
						contentBorderTopWidth: "0px",
						contentMarginLeft: "0px",
						contentMarginBottom: "0px",
						contentMarginRight: "0px",
						contentMarginTop: "0px",
						contentPaddingLeft: "0px",
						contentPaddingBottom: "0px",
						contentPaddingRight: "0px",
						contentPaddingTop: "0px",
						contentWidth: 600,
						bodyWidth: 600,
					},
					customData: {},
				},
				{
					eid: "b2AA9UG-2",
					type: "fullwidth",
					children: [
						{
							eid: "z8U0t5oL9O",
							type: "multicolumn",
							children: [
								{
									eid: "wfLh30cUgA",
									type: "column",
									children: [
										{
											eid: "sSlP2BMHb",
											type: "multicolumn",
											children: [
												{
													eid: "OwrOtnraWx",
													type: "column",
													children: [
														{
															eid: "A1AghrhOK",
															type: "image",
															attrs: {
																title: "",
																link: "",
																altText: "",
																src: "https://placehold.co/150/ededed/1762C5.png",
															},
															style: {
																fullWidthOnMobile: false,
																align: "center",
																lockedWidth: null,
																lockedHeight: null,
																maxHeight: "150px",
																maxWidth: "150px",
																width: "150px",
																backgroundColor: "",
																backgroundRepeat: "no-repeat",
																backgroundPosition: "center center",
																backgroundImage: "",
																backgroundSize: "auto",
																borderRadius: "0px",
																borderLeftColor: "#121212",
																borderLeftStyle: "solid",
																borderLeftWidth: "0px",
																borderBottomColor: "#121212",
																borderBottomStyle: "solid",
																borderBottomWidth: "0px",
																borderRightColor: "#121212",
																borderRightStyle: "solid",
																borderRightWidth: "0px",
																borderTopColor: "#121212",
																borderTopStyle: "solid",
																borderTopWidth: "0px",
																marginLeft: "0px",
																marginBottom: "0px",
																marginRight: "0px",
																marginTop: "0px",
																paddingLeft: "0px",
																paddingBottom: "0px",
																paddingRight: "0px",
																paddingTop: "0px",
															},
															customData: null,
														},
													],
													attrs: {
														hideOnMobile: false,
														lock: false,
													},
													style: {
														width: "150px",
														backgroundColor: "",
														backgroundRepeat: "no-repeat",
														backgroundPosition: "center center",
														backgroundImage: "",
														backgroundSize: "auto",
													},
													customData: {},
												},
												{
													eid: "uXXMaDUKzH",
													type: "column",
													children: [
														{
															eid: "hl9JTBp9M",
															type: "box",
															children: [
																{
																	eid: "5DucigUVy",
																	type: "text",
																	attrs: {
																		text: "<p style=\"text-align: center;\">Style, Fast, Mission</p>\n",
																	},
																	style: {
																		backgroundColor: "",
																		backgroundRepeat: "no-repeat",
																		backgroundPosition: "center center",
																		backgroundImage: "",
																		backgroundSize: "auto",
																		paddingLeft: "10px",
																		paddingBottom: "5px",
																		paddingRight: "10px",
																		paddingTop: "5px",
																		paragraphLineHeight: "25px",
																		paragraphLetterSpacing: "normal",
																		paragraphColor: "#FFFFFF",
																		paragraphFontSize: "18px",
																		paragraphFontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif",
																		linkTextDecoration: "underline",
																		linkColor: "#00c0e7",
																		h3LineHeight: "27px",
																		h3Color: "#000000",
																		h3FontSize: "22px",
																		h3FontFamily: "Georgia, Times, Times New Roman, serif",
																		h3LetterSpacing: "normal",
																		h2LineHeight: "34px",
																		h2Color: "#000000",
																		h2FontSize: "26px",
																		h2FontFamily: "Georgia, Times, Times New Roman, serif",
																		h2LetterSpacing: "normal",
																		h1LineHeight: "40px",
																		h1Color: "#000000",
																		h1FontSize: "33px",
																		h1FontFamily: "Georgia, Times, Times New Roman, serif",
																		h1LetterSpacing: "normal",
																		h6: {},
																		h5: {},
																		h4: {},
																	},
																	customData: null,
																},
															],
															attrs: {
																hideOnMobile: false,
																hideOnDesktop: false,
															},
															style: {
																backgroundColor: "transparent",
																backgroundRepeat: "no-repeat",
																backgroundPosition: "center center",
																backgroundImage: "",
																backgroundSize: "auto",
																borderRadius: "0px",
																borderLeftColor: "#121212",
																borderLeftStyle: "solid",
																borderLeftWidth: "0px",
																borderBottomColor: "#121212",
																borderBottomStyle: "solid",
																borderBottomWidth: "0px",
																borderRightColor: "#121212",
																borderRightStyle: "solid",
																borderRightWidth: "0px",
																borderTopColor: "#121212",
																borderTopStyle: "solid",
																borderTopWidth: "0px",
																marginLeft: "0px",
																marginBottom: "0px",
																marginRight: "0px",
																marginTop: "0px",
																paddingLeft: "0px",
																paddingBottom: "0px",
																paddingRight: "0px",
																paddingTop: "45px",
															},
															customData: {},
														},
													],
													attrs: {
														hideOnMobile: false,
														lock: false,
													},
													style: {
														width: "150px",
														backgroundColor: {
															reference: "PrimaryColor",
															default: "#FF0000",
														},
														backgroundRepeat: "no-repeat",
														backgroundPosition: "center center",
														backgroundImage: "",
														backgroundSize: "auto",
													},
													customData: {},
												},
											],
											attrs: {
												hideOnMobile: false,
												hideOnDesktop: false,
												stacking: "none",
												spacerBefore: "0px",
												spacerBetween: "0px",
												spacerAfter: "0px",
												spacerBeforeMobile: "0px",
												spacerBetweenMobile: "0px",
												spacerAfterMobile: "0px",
											},
											style: {
												backgroundColor: "",
												backgroundRepeat: "no-repeat",
												backgroundPosition: "center center",
												backgroundImage: "",
												backgroundSize: "auto",
											},
											customData: {},
										},
										{
											eid: "hBRh8If0M",
											type: "multicolumn",
											children: [
												{
													eid: "b6e4e2vas-",
													type: "column",
													children: [
														{
															eid: "Qw_xROrswq",
															type: "box",
															children: [
																{
																	eid: "8I9Hc45I5n",
																	type: "text",
																	attrs: {
																		text: "<p style=\"text-align: center;\">Style, Fast, Mission</p>\n",
																	},
																	style: {
																		backgroundColor: "",
																		backgroundRepeat: "no-repeat",
																		backgroundPosition: "center center",
																		backgroundImage: "",
																		backgroundSize: "auto",
																		paddingLeft: "10px",
																		paddingBottom: "5px",
																		paddingRight: "10px",
																		paddingTop: "5px",
																		paragraphLineHeight: "25px",
																		paragraphLetterSpacing: "normal",
																		paragraphColor: "#FFFFFF",
																		paragraphFontSize: "18px",
																		paragraphFontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif",
																		linkTextDecoration: "underline",
																		linkColor: "#00c0e7",
																		h3LineHeight: "27px",
																		h3Color: "#000000",
																		h3FontSize: "22px",
																		h3FontFamily: "Georgia, Times, Times New Roman, serif",
																		h3LetterSpacing: "normal",
																		h2LineHeight: "34px",
																		h2Color: "#000000",
																		h2FontSize: "26px",
																		h2FontFamily: "Georgia, Times, Times New Roman, serif",
																		h2LetterSpacing: "normal",
																		h1LineHeight: "40px",
																		h1Color: "#000000",
																		h1FontSize: "33px",
																		h1FontFamily: "Georgia, Times, Times New Roman, serif",
																		h1LetterSpacing: "normal",
																		h6: {},
																		h5: {},
																		h4: {},
																	},
																	customData: null,
																},
															],
															attrs: {
																hideOnMobile: false,
																hideOnDesktop: false,
															},
															style: {
																backgroundColor: "transparent",
																backgroundRepeat: "no-repeat",
																backgroundPosition: "center center",
																backgroundImage: "",
																backgroundSize: "auto",
																borderRadius: "0px",
																borderLeftColor: "#121212",
																borderLeftStyle: "solid",
																borderLeftWidth: "0px",
																borderBottomColor: "#121212",
																borderBottomStyle: "solid",
																borderBottomWidth: "0px",
																borderRightColor: "#121212",
																borderRightStyle: "solid",
																borderRightWidth: "0px",
																borderTopColor: "#121212",
																borderTopStyle: "solid",
																borderTopWidth: "0px",
																marginLeft: "0px",
																marginBottom: "0px",
																marginRight: "0px",
																marginTop: "0px",
																paddingLeft: "0px",
																paddingBottom: "0px",
																paddingRight: "0px",
																paddingTop: "45px",
															},
															customData: {},
														},
													],
													attrs: {
														hideOnMobile: false,
														lock: false,
													},
													style: {
														width: "150px",
														backgroundColor: {
															reference: "PrimaryColor",
															default: "",
														},
														backgroundRepeat: "no-repeat",
														backgroundPosition: "center center",
														backgroundImage: "",
														backgroundSize: "auto",
													},
													customData: {},
												},
												{
													eid: "FlWTwxdJy",
													type: "column",
													children: [
														{
															eid: "hMHCy8w95n",
															type: "image",
															attrs: {
																title: "",
																link: "",
																altText: "",
																src: "https://placehold.co/150/a1a1a1/5C9AEB.png",
															},
															style: {
																fullWidthOnMobile: false,
																align: "center",
																lockedWidth: null,
																lockedHeight: null,
																maxHeight: "150px",
																maxWidth: "150px",
																width: "150px",
																backgroundColor: "",
																backgroundRepeat: "no-repeat",
																backgroundPosition: "center center",
																backgroundImage: "",
																backgroundSize: "auto",
																borderRadius: "0px",
																borderLeftColor: "#121212",
																borderLeftStyle: "solid",
																borderLeftWidth: "0px",
																borderBottomColor: "#121212",
																borderBottomStyle: "solid",
																borderBottomWidth: "0px",
																borderRightColor: "#121212",
																borderRightStyle: "solid",
																borderRightWidth: "0px",
																borderTopColor: "#121212",
																borderTopStyle: "solid",
																borderTopWidth: "0px",
																marginLeft: "0px",
																marginBottom: "0px",
																marginRight: "0px",
																marginTop: "0px",
																paddingLeft: "0px",
																paddingBottom: "0px",
																paddingRight: "0px",
																paddingTop: "0px",
															},
															customData: null,
														},
													],
													attrs: {
														hideOnMobile: false,
														lock: false,
													},
													style: {
														width: "150px",
														backgroundColor: "",
														backgroundRepeat: "no-repeat",
														backgroundPosition: "center center",
														backgroundImage: "",
														backgroundSize: "auto",
													},
													customData: {},
												},
											],
											attrs: {
												hideOnMobile: false,
												hideOnDesktop: false,
												stacking: "none",
												spacerBefore: "0px",
												spacerBetween: "0px",
												spacerAfter: "0px",
												spacerBeforeMobile: "0px",
												spacerBetweenMobile: "0px",
												spacerAfterMobile: "0px",
											},
											style: {
												backgroundColor: "",
												backgroundRepeat: "no-repeat",
												backgroundPosition: "center center",
												backgroundImage: "",
												backgroundSize: "auto",
											},
											customData: {},
										},
									],
									attrs: {
										hideOnMobile: false,
										lock: false,
									},
									style: {
										width: "300px",
										backgroundColor: "",
										backgroundRepeat: "no-repeat",
										backgroundPosition: "center center",
										backgroundImage: "",
										backgroundSize: "auto",
									},
									customData: {},
								},
								{
									eid: "FlKQkkw6B",
									type: "column",
									children: [
										{
											eid: "VmOIxp1QCN",
											type: "multicolumn",
											children: [
												{
													eid: "dSNFBOC-xn",
													type: "column",
													children: [
														{
															eid: "A_ZHeWLTL1",
															type: "image",
															attrs: {
																title: "",
																link: "",
																altText: "",
																src: "https://placehold.co/150/ededed/1762C5.png",
															},
															style: {
																fullWidthOnMobile: false,
																align: "center",
																lockedWidth: 150,
																lockedHeight: 150,
																maxHeight: "150px",
																maxWidth: "150px",
																width: "150px",
																backgroundColor: "",
																backgroundRepeat: "no-repeat",
																backgroundPosition: "center center",
																backgroundImage: "",
																backgroundSize: "auto",
																borderRadius: "0px",
																borderLeftColor: "#121212",
																borderLeftStyle: "solid",
																borderLeftWidth: "0px",
																borderBottomColor: "#121212",
																borderBottomStyle: "solid",
																borderBottomWidth: "0px",
																borderRightColor: "#121212",
																borderRightStyle: "solid",
																borderRightWidth: "0px",
																borderTopColor: "#121212",
																borderTopStyle: "solid",
																borderTopWidth: "0px",
																marginLeft: "0px",
																marginBottom: "0px",
																marginRight: "0px",
																marginTop: "0px",
																paddingLeft: "0px",
																paddingBottom: "0px",
																paddingRight: "0px",
																paddingTop: "0px",
															},
															customData: null,
														},
													],
													attrs: {
														hideOnMobile: false,
														lock: false,
													},
													style: {
														width: "150px",
														backgroundColor: "",
														backgroundRepeat: "no-repeat",
														backgroundPosition: "center center",
														backgroundImage: "",
														backgroundSize: "auto",
													},
													customData: {},
												},
												{
													eid: "3sIyxV5CNG",
													type: "column",
													children: [
														{
															eid: "U8pPQN86b-",
															type: "box",
															children: [
																{
																	eid: "bIBBZQ9Ksf",
																	type: "text",
																	attrs: {
																		text: "<p style=\"text-align: center;\">Style, Fast, Mission</p>\n",
																	},
																	style: {
																		backgroundColor: "",
																		backgroundRepeat: "no-repeat",
																		backgroundPosition: "center center",
																		backgroundImage: "",
																		backgroundSize: "auto",
																		paddingLeft: "10px",
																		paddingBottom: "5px",
																		paddingRight: "10px",
																		paddingTop: "5px",
																		paragraphLineHeight: "25px",
																		paragraphLetterSpacing: "normal",
																		paragraphColor: "#FFFFFF",
																		paragraphFontSize: "18px",
																		paragraphFontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif",
																		linkTextDecoration: "underline",
																		linkColor: "#00c0e7",
																		h3LineHeight: "27px",
																		h3Color: "#000000",
																		h3FontSize: "22px",
																		h3FontFamily: "Georgia, Times, Times New Roman, serif",
																		h3LetterSpacing: "normal",
																		h2LineHeight: "34px",
																		h2Color: "#000000",
																		h2FontSize: "26px",
																		h2FontFamily: "Georgia, Times, Times New Roman, serif",
																		h2LetterSpacing: "normal",
																		h1LineHeight: "40px",
																		h1Color: "#000000",
																		h1FontSize: "33px",
																		h1FontFamily: "Georgia, Times, Times New Roman, serif",
																		h1LetterSpacing: "normal",
																		h6: {},
																		h5: {},
																		h4: {},
																	},
																	customData: null,
																},
															],
															attrs: {
																hideOnMobile: false,
																hideOnDesktop: false,
															},
															style: {
																backgroundColor: "transparent",
																backgroundRepeat: "no-repeat",
																backgroundPosition: "center center",
																backgroundImage: "",
																backgroundSize: "auto",
																borderRadius: "0px",
																borderLeftColor: "#121212",
																borderLeftStyle: "solid",
																borderLeftWidth: "0px",
																borderBottomColor: "#121212",
																borderBottomStyle: "solid",
																borderBottomWidth: "0px",
																borderRightColor: "#121212",
																borderRightStyle: "solid",
																borderRightWidth: "0px",
																borderTopColor: "#121212",
																borderTopStyle: "solid",
																borderTopWidth: "0px",
																marginLeft: "0px",
																marginBottom: "0px",
																marginRight: "0px",
																marginTop: "0px",
																paddingLeft: "0px",
																paddingBottom: "0px",
																paddingRight: "0px",
																paddingTop: "45px",
															},
															customData: {},
														},
													],
													attrs: {
														hideOnMobile: false,
														lock: false,
													},
													style: {
														width: "150px",
														backgroundColor: {
															reference: "PrimaryColor",
															default: "",
														},
														backgroundRepeat: "no-repeat",
														backgroundPosition: "center center",
														backgroundImage: "",
														backgroundSize: "auto",
													},
													customData: {},
												},
											],
											attrs: {
												hideOnMobile: false,
												hideOnDesktop: false,
												stacking: "none",
												spacerBefore: "0px",
												spacerBetween: "0px",
												spacerAfter: "0px",
												spacerBeforeMobile: "0px",
												spacerBetweenMobile: "0px",
												spacerAfterMobile: "0px",
											},
											style: {
												backgroundColor: "",
												backgroundRepeat: "no-repeat",
												backgroundPosition: "center center",
												backgroundImage: "",
												backgroundSize: "auto",
											},
											customData: {},
										},
										{
											eid: "kw-VZrWUP",
											type: "multicolumn",
											children: [
												{
													eid: "N4yzgCtows",
													type: "column",
													children: [
														{
															eid: "GcOsUmGDeF",
															type: "box",
															children: [
																{
																	eid: "wR6qFZ1Jld",
																	type: "text",
																	attrs: {
																		text: "<p style=\"text-align: center;\">Style, Fast, Mission</p>\n",
																	},
																	style: {
																		backgroundColor: "",
																		backgroundRepeat: "no-repeat",
																		backgroundPosition: "center center",
																		backgroundImage: "",
																		backgroundSize: "auto",
																		paddingLeft: "10px",
																		paddingBottom: "5px",
																		paddingRight: "10px",
																		paddingTop: "5px",
																		paragraphLineHeight: "25px",
																		paragraphLetterSpacing: "normal",
																		paragraphColor: "#FFFFFF",
																		paragraphFontSize: "18px",
																		paragraphFontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif",
																		linkTextDecoration: "underline",
																		linkColor: "#00c0e7",
																		h3LineHeight: "27px",
																		h3Color: "#000000",
																		h3FontSize: "22px",
																		h3FontFamily: "Georgia, Times, Times New Roman, serif",
																		h3LetterSpacing: "normal",
																		h2LineHeight: "34px",
																		h2Color: "#000000",
																		h2FontSize: "26px",
																		h2FontFamily: "Georgia, Times, Times New Roman, serif",
																		h2LetterSpacing: "normal",
																		h1LineHeight: "40px",
																		h1Color: "#000000",
																		h1FontSize: "33px",
																		h1FontFamily: "Georgia, Times, Times New Roman, serif",
																		h1LetterSpacing: "normal",
																		h6: {},
																		h5: {},
																		h4: {},
																	},
																	customData: null,
																},
															],
															attrs: {
																hideOnMobile: false,
																hideOnDesktop: false,
															},
															style: {
																backgroundColor: "transparent",
																backgroundRepeat: "no-repeat",
																backgroundPosition: "center center",
																backgroundImage: "",
																backgroundSize: "auto",
																borderRadius: "0px",
																borderLeftColor: "#121212",
																borderLeftStyle: "solid",
																borderLeftWidth: "0px",
																borderBottomColor: "#121212",
																borderBottomStyle: "solid",
																borderBottomWidth: "0px",
																borderRightColor: "#121212",
																borderRightStyle: "solid",
																borderRightWidth: "0px",
																borderTopColor: "#121212",
																borderTopStyle: "solid",
																borderTopWidth: "0px",
																marginLeft: "0px",
																marginBottom: "0px",
																marginRight: "0px",
																marginTop: "0px",
																paddingLeft: "0px",
																paddingBottom: "0px",
																paddingRight: "0px",
																paddingTop: "45px",
															},
															customData: {},
														},
													],
													attrs: {
														hideOnMobile: false,
														lock: false,
													},
													style: {
														width: "150px",
														backgroundColor: {
															reference: "PrimaryColor",
															default: "",
														},
														backgroundRepeat: "no-repeat",
														backgroundPosition: "center center",
														backgroundImage: "",
														backgroundSize: "auto",
													},
													customData: {},
												},
												{
													eid: "bzgnZNCzSG",
													type: "column",
													children: [
														{
															eid: "n4aGw7cDVL",
															type: "image",
															attrs: {
																title: "",
																link: "",
																altText: "",
																src: "https://placehold.co/150/a1a1a1/5C9AEB.png",
															},
															style: {
																fullWidthOnMobile: false,
																align: "center",
																lockedWidth: 150,
																lockedHeight: 150,
																maxHeight: "150px",
																maxWidth: "150px",
																width: "150px",
																backgroundColor: "",
																backgroundRepeat: "no-repeat",
																backgroundPosition: "center center",
																backgroundImage: "",
																backgroundSize: "auto",
																borderRadius: "0px",
																borderLeftColor: "#121212",
																borderLeftStyle: "solid",
																borderLeftWidth: "0px",
																borderBottomColor: "#121212",
																borderBottomStyle: "solid",
																borderBottomWidth: "0px",
																borderRightColor: "#121212",
																borderRightStyle: "solid",
																borderRightWidth: "0px",
																borderTopColor: "#121212",
																borderTopStyle: "solid",
																borderTopWidth: "0px",
																marginLeft: "0px",
																marginBottom: "0px",
																marginRight: "0px",
																marginTop: "0px",
																paddingLeft: "0px",
																paddingBottom: "0px",
																paddingRight: "0px",
																paddingTop: "0px",
															},
															customData: null,
														},
													],
													attrs: {
														hideOnMobile: false,
														lock: false,
													},
													style: {
														width: "150px",
														backgroundColor: "",
														backgroundRepeat: "no-repeat",
														backgroundPosition: "center center",
														backgroundImage: "",
														backgroundSize: "auto",
													},
													customData: {},
												},
											],
											attrs: {
												hideOnMobile: false,
												hideOnDesktop: false,
												stacking: "none",
												spacerBefore: "0px",
												spacerBetween: "0px",
												spacerAfter: "0px",
												spacerBeforeMobile: "0px",
												spacerBetweenMobile: "0px",
												spacerAfterMobile: "0px",
											},
											style: {
												backgroundColor: "",
												backgroundRepeat: "no-repeat",
												backgroundPosition: "center center",
												backgroundImage: "",
												backgroundSize: "auto",
											},
											customData: {},
										},
									],
									attrs: {
										hideOnMobile: false,
										lock: false,
									},
									style: {
										width: "300px",
										backgroundColor: "",
										backgroundRepeat: "no-repeat",
										backgroundPosition: "center center",
										backgroundImage: "",
										backgroundSize: "auto",
									},
									customData: {},
								},
							],
							attrs: {
								hideOnMobile: false,
								hideOnDesktop: false,
								stacking: "left-on-top",
								spacerBefore: "0px",
								spacerBetween: "0px",
								spacerAfter: "0px",
								spacerBeforeMobile: "0px",
								spacerBetweenMobile: "0px",
								spacerAfterMobile: "0px",
							},
							style: {
								backgroundColor: "",
								backgroundRepeat: "no-repeat",
								backgroundPosition: "center center",
								backgroundImage: "",
								backgroundSize: "auto",
							},
							customData: {},
						},
					],
					placeholder: [],
					attrs: {
						hideOnMobile: false,
						hideOnDesktop: false,
						lock: false,
						marker: "",
					},
					style: {
						backgroundColor: "",
						backgroundRepeat: "no-repeat",
						backgroundPosition: "center center",
						backgroundImage: "",
						backgroundSize: "auto",
						contentBackgroundColor: "#1762C5",
						contentBackgroundRepeat: "no-repeat",
						contentBackgroundPosition: "center center",
						contentBackgroundImage: "",
						contentBackgroundSize: "auto",
						contentBorderRadius: "0px",
						contentBorderLeftColor: "#121212",
						contentBorderLeftStyle: "solid",
						contentBorderLeftWidth: "0px",
						contentBorderBottomColor: "#121212",
						contentBorderBottomStyle: "solid",
						contentBorderBottomWidth: "0px",
						contentBorderRightColor: "#121212",
						contentBorderRightStyle: "solid",
						contentBorderRightWidth: "0px",
						contentBorderTopColor: "#121212",
						contentBorderTopStyle: "solid",
						contentBorderTopWidth: "0px",
						contentMarginLeft: "0px",
						contentMarginBottom: "0px",
						contentMarginRight: "0px",
						contentMarginTop: "0px",
						contentPaddingLeft: "0px",
						contentPaddingBottom: "0px",
						contentPaddingRight: "0px",
						contentPaddingTop: "0px",
						contentWidth: 600,
						bodyWidth: 600,
					},
					customData: {},
				},
				{
					eid: "DiY-AfD8o",
					type: "fullwidth",
					children: [
						{
							eid: "wsnKxUYpdg",
							type: "box",
							children: [
								{
									eid: "KdrQAZQGFk",
									type: "text",
									attrs: {
										text: "<p style=\"text-align: center;\"><strong>Services we provide</strong></p>\n",
									},
									style: {
										backgroundColor: "",
										backgroundRepeat: "no-repeat",
										backgroundPosition: "center center",
										backgroundImage: "",
										backgroundSize: "auto",
										paddingLeft: "10px",
										paddingBottom: "0px",
										paddingRight: "10px",
										paddingTop: "5px",
										paragraphLineHeight: "40px",
										paragraphLetterSpacing: "normal",
										paragraphColor: {
											reference: "PrimaryColor",
											default: "#165BB4",
										},
										paragraphFontSize: "35px",
										paragraphFontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif",
										linkTextDecoration: "none",
										linkColor: "#165bb4",
										h3LineHeight: "22px",
										h3Color: "#000000",
										h3FontSize: "22px",
										h3FontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif",
										h3LetterSpacing: "normal",
										h2LineHeight: "26px",
										h2Color: "#000000",
										h2FontSize: "26px",
										h2FontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif",
										h2LetterSpacing: "normal",
										h1LineHeight: "32px",
										h1Color: "#000000",
										h1FontSize: "32px",
										h1FontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif",
										h1LetterSpacing: "normal",
										h6: {
											"line-height": "16px",
											color: "#000000",
											"font-size": "16px",
											"font-family": "arial",
										},
										h5: {
											"line-height": "18px",
											color: "#000000",
											"font-size": "18px",
											"font-family": "arial",
										},
										h4: {
											"line-height": "20px",
											color: "#000000",
											"font-size": "20px",
											"font-family": "arial",
										},
									},
									customData: null,
								},
								{
									eid: "tFyeP6HSI",
									type: "text",
									attrs: {
										text: "<p style=\"text-align: center;\">LET&#39;S START WITH US!</p>\n",
									},
									style: {
										backgroundColor: "",
										backgroundRepeat: "no-repeat",
										backgroundPosition: "center center",
										backgroundImage: "",
										backgroundSize: "auto",
										paddingLeft: "10px",
										paddingBottom: "15px",
										paddingRight: "10px",
										paddingTop: "5px",
										paragraphLineHeight: "20px",
										paragraphLetterSpacing: "normal",
										paragraphColor: {
											reference: "SecondaryColor",
											default: "#5C9AEB",
										},
										paragraphFontSize: "15px",
										paragraphFontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif",
										linkTextDecoration: "underline",
										linkColor: "#00c0e7",
										h3LineHeight: "27px",
										h3Color: "#000000",
										h3FontSize: "22px",
										h3FontFamily: "Georgia, Times, Times New Roman, serif",
										h3LetterSpacing: "normal",
										h2LineHeight: "34px",
										h2Color: "#000000",
										h2FontSize: "26px",
										h2FontFamily: "Georgia, Times, Times New Roman, serif",
										h2LetterSpacing: "normal",
										h1LineHeight: "40px",
										h1Color: "#000000",
										h1FontSize: "33px",
										h1FontFamily: "Georgia, Times, Times New Roman, serif",
										h1LetterSpacing: "normal",
										h6: {},
										h5: {},
										h4: {},
									},
									customData: null,
								},
								{
									eid: "VHGPLe3xO",
									type: "box",
									children: [
										{
											eid: "1BAuUhov5v",
											type: "multicolumn",
											children: [
												{
													eid: "i_jiHS0i-g",
													type: "column",
													children: [
														{
															eid: "tNo9NLGGBT",
															type: "box",
															children: [
																{
																	eid: "qBJCTww9x6",
																	type: "box",
																	children: [
																		{
																			eid: "rq7GlmF2WI",
																			type: "image",
																			attrs: {
																				title: "",
																				link: "",
																				altText: "",
																				src: "https://placehold.co/270/a1a1a1/5C9AEB.png",
																			},
																			style: {
																				fullWidthOnMobile: true,
																				align: "center",
																				lockedWidth: 150,
																				lockedHeight: 150,
																				maxHeight: "270px",
																				maxWidth: "270px",
																				width: "270px",
																				backgroundColor: "",
																				backgroundRepeat: "no-repeat",
																				backgroundPosition: "center center",
																				backgroundImage: "",
																				backgroundSize: "auto",
																				borderRadius: "0px",
																				borderLeftColor: "#121212",
																				borderLeftStyle: "solid",
																				borderLeftWidth: "0px",
																				borderBottomColor: "#121212",
																				borderBottomStyle: "solid",
																				borderBottomWidth: "0px",
																				borderRightColor: "#EDF4FD",
																				borderRightStyle: "solid",
																				borderRightWidth: "0px",
																				borderTopColor: "#EDF4FD",
																				borderTopStyle: "solid",
																				borderTopWidth: "0px",
																				marginLeft: "0px",
																				marginBottom: "0px",
																				marginRight: "0px",
																				marginTop: "0px",
																				paddingLeft: "0px",
																				paddingBottom: "0px",
																				paddingRight: "0px",
																				paddingTop: "0px",
																			},
																			customData: null,
																		},
																	],
																	attrs: {
																		hideOnMobile: false,
																		hideOnDesktop: false,
																	},
																	style: {
																		backgroundColor: "",
																		backgroundRepeat: "no-repeat",
																		backgroundPosition: "right top",
																		backgroundImage: "",
																		backgroundSize: "auto",
																		borderRadius: "0px",
																		borderLeftColor: "#121212",
																		borderLeftStyle: "solid",
																		borderLeftWidth: "0px",
																		borderBottomColor: "#121212",
																		borderBottomStyle: "solid",
																		borderBottomWidth: "0px",
																		borderRightColor: "#EDF4FD",
																		borderRightStyle: "solid",
																		borderRightWidth: "0px",
																		borderTopColor: "#EDF4FD",
																		borderTopStyle: "solid",
																		borderTopWidth: "0px",
																		marginLeft: "10px",
																		marginBottom: "0px",
																		marginRight: "10px",
																		marginTop: "10px",
																		paddingLeft: "0px",
																		paddingBottom: "0px",
																		paddingRight: "0px",
																		paddingTop: "0px",
																	},
																	customData: {},
																},
																{
																	eid: "zKvFlwFUK",
																	type: "box",
																	children: [
																		{
																			eid: "S59DpNVhHs",
																			type: "text",
																			attrs: {
																				text: "<p style=\"text-align: center;\"><strong>Jim Carry, Phd. -&nbsp;FOUNDER</strong></p>\n",
																			},
																			style: {
																				backgroundColor: "#EDF4FD",
																				backgroundRepeat: "no-repeat",
																				backgroundPosition: "center center",
																				backgroundImage: "",
																				backgroundSize: "auto",
																				paddingLeft: "10px",
																				paddingBottom: "5px",
																				paddingRight: "10px",
																				paddingTop: "5px",
																				paragraphLineHeight: "29px",
																				paragraphLetterSpacing: "normal",
																				paragraphColor: "#141414",
																				paragraphFontSize: "16px",
																				paragraphFontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif",
																				linkTextDecoration: "underline",
																				linkColor: "#00c0e7",
																				h3LineHeight: "27px",
																				h3Color: "#000000",
																				h3FontSize: "22px",
																				h3FontFamily: "Georgia, Times, Times New Roman, serif",
																				h3LetterSpacing: "normal",
																				h2LineHeight: "34px",
																				h2Color: "#000000",
																				h2FontSize: "26px",
																				h2FontFamily: "Georgia, Times, Times New Roman, serif",
																				h2LetterSpacing: "normal",
																				h1LineHeight: "40px",
																				h1Color: "#000000",
																				h1FontSize: "33px",
																				h1FontFamily: "Georgia, Times, Times New Roman, serif",
																				h1LetterSpacing: "normal",
																				h6: {},
																				h5: {},
																				h4: {},
																			},
																			customData: null,
																		},
																	],
																	attrs: {
																		hideOnMobile: false,
																		hideOnDesktop: false,
																	},
																	style: {
																		backgroundColor: "",
																		backgroundRepeat: "no-repeat",
																		backgroundPosition: "center center",
																		backgroundImage: "",
																		backgroundSize: "auto",
																		borderRadius: "0px",
																		borderLeftColor: "#121212",
																		borderLeftStyle: "solid",
																		borderLeftWidth: "0px",
																		borderBottomColor: "#121212",
																		borderBottomStyle: "solid",
																		borderBottomWidth: "0px",
																		borderRightColor: "#121212",
																		borderRightStyle: "solid",
																		borderRightWidth: "0px",
																		borderTopColor: "#121212",
																		borderTopStyle: "solid",
																		borderTopWidth: "0px",
																		marginLeft: "10px",
																		marginBottom: "0px",
																		marginRight: "10px",
																		marginTop: "0px",
																		paddingLeft: "0px",
																		paddingBottom: "0px",
																		paddingRight: "0px",
																		paddingTop: "0px",
																	},
																	customData: {},
																},
																{
																	eid: "pw4nn1lZ4q",
																	type: "text",
																	attrs: {
																		text: "<p style=\"text-align: center;\">FOUNDER</p>\n",
																	},
																	style: {
																		backgroundColor: "",
																		backgroundRepeat: "no-repeat",
																		backgroundPosition: "center center",
																		backgroundImage: "",
																		backgroundSize: "auto",
																		paddingLeft: "10px",
																		paddingBottom: "0px",
																		paddingRight: "10px",
																		paddingTop: "0px",
																		paragraphLineHeight: "25px",
																		paragraphLetterSpacing: "normal",
																		paragraphColor: {
																			reference: "PrimaryColor",
																			default: "#1762C5",
																		},
																		paragraphFontSize: "14px",
																		paragraphFontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif",
																		linkTextDecoration: "underline",
																		linkColor: "#00c0e7",
																		h3LineHeight: "27px",
																		h3Color: "#000000",
																		h3FontSize: "22px",
																		h3FontFamily: "Georgia, Times, Times New Roman, serif",
																		h3LetterSpacing: "normal",
																		h2LineHeight: "34px",
																		h2Color: "#000000",
																		h2FontSize: "26px",
																		h2FontFamily: "Georgia, Times, Times New Roman, serif",
																		h2LetterSpacing: "normal",
																		h1LineHeight: "40px",
																		h1Color: "#000000",
																		h1FontSize: "33px",
																		h1FontFamily: "Georgia, Times, Times New Roman, serif",
																		h1LetterSpacing: "normal",
																		h6: {},
																		h5: {},
																		h4: {},
																	},
																	customData: null,
																},
															],
															attrs: {
																hideOnMobile: false,
																hideOnDesktop: false,
															},
															style: {
																backgroundColor: "transparent",
																backgroundRepeat: "no-repeat",
																backgroundPosition: "center center",
																backgroundImage: "",
																backgroundSize: "auto",
																borderRadius: "0px",
																borderLeftColor: "#121212",
																borderLeftStyle: "solid",
																borderLeftWidth: "0px",
																borderBottomColor: "#121212",
																borderBottomStyle: "solid",
																borderBottomWidth: "0px",
																borderRightColor: "#121212",
																borderRightStyle: "solid",
																borderRightWidth: "0px",
																borderTopColor: "#121212",
																borderTopStyle: "solid",
																borderTopWidth: "0px",
																marginLeft: "0px",
																marginBottom: "0px",
																marginRight: "0px",
																marginTop: "0px",
																paddingLeft: "0px",
																paddingBottom: "10px",
																paddingRight: "0px",
																paddingTop: "0px",
															},
															customData: {},
														},
													],
													attrs: {
														hideOnMobile: false,
														lock: false,
													},
													style: {
														width: "290px",
														backgroundColor: "",
														backgroundRepeat: "no-repeat",
														backgroundPosition: "center center",
														backgroundImage: "",
														backgroundSize: "auto",
													},
													customData: {},
												},
												{
													eid: "k8n1aaqEw",
													type: "column",
													children: [
														{
															eid: "vgbmEnk3bf",
															type: "box",
															children: [
																{
																	eid: "ehpPn6K-LQ",
																	type: "box",
																	children: [
																		{
																			eid: "cw_ywdxVcw",
																			type: "image",
																			attrs: {
																				title: "",
																				link: "",
																				altText: "",
																				src: "https://placehold.co/270/a1a1a1/5C9AEB.png",
																			},
																			style: {
																				fullWidthOnMobile: true,
																				align: "center",
																				lockedWidth: 150,
																				lockedHeight: 150,
																				maxHeight: "270px",
																				maxWidth: "270px",
																				width: "270px",
																				backgroundColor: "",
																				backgroundRepeat: "no-repeat",
																				backgroundPosition: "center center",
																				backgroundImage: "",
																				backgroundSize: "auto",
																				borderRadius: "0px",
																				borderLeftColor: "#121212",
																				borderLeftStyle: "solid",
																				borderLeftWidth: "0px",
																				borderBottomColor: "#121212",
																				borderBottomStyle: "solid",
																				borderBottomWidth: "0px",
																				borderRightColor: "#EDF4FD",
																				borderRightStyle: "solid",
																				borderRightWidth: "0px",
																				borderTopColor: "#EDF4FD",
																				borderTopStyle: "solid",
																				borderTopWidth: "0px",
																				marginLeft: "0px",
																				marginBottom: "0px",
																				marginRight: "0px",
																				marginTop: "0px",
																				paddingLeft: "0px",
																				paddingBottom: "0px",
																				paddingRight: "0px",
																				paddingTop: "0px",
																			},
																			customData: null,
																		},
																	],
																	attrs: {
																		hideOnMobile: false,
																		hideOnDesktop: false,
																	},
																	style: {
																		backgroundColor: "",
																		backgroundRepeat: "no-repeat",
																		backgroundPosition: "right top",
																		backgroundImage: "",
																		backgroundSize: "auto",
																		borderRadius: "0px",
																		borderLeftColor: "#121212",
																		borderLeftStyle: "solid",
																		borderLeftWidth: "0px",
																		borderBottomColor: "#121212",
																		borderBottomStyle: "solid",
																		borderBottomWidth: "0px",
																		borderRightColor: "#EDF4FD",
																		borderRightStyle: "solid",
																		borderRightWidth: "0px",
																		borderTopColor: "#EDF4FD",
																		borderTopStyle: "solid",
																		borderTopWidth: "0px",
																		marginLeft: "10px",
																		marginBottom: "0px",
																		marginRight: "10px",
																		marginTop: "10px",
																		paddingLeft: "0px",
																		paddingBottom: "0px",
																		paddingRight: "0px",
																		paddingTop: "0px",
																	},
																	customData: {},
																},
																{
																	eid: "TuteMimNDR",
																	type: "box",
																	children: [
																		{
																			eid: "ztrWNjrt1p",
																			type: "text",
																			attrs: {
																				text: "<p style=\"text-align: center;\"><strong>Jim Carry, Phd. -&nbsp;FOUNDER</strong></p>\n",
																			},
																			style: {
																				backgroundColor: "#EDF4FD",
																				backgroundRepeat: "no-repeat",
																				backgroundPosition: "center center",
																				backgroundImage: "",
																				backgroundSize: "auto",
																				paddingLeft: "10px",
																				paddingBottom: "5px",
																				paddingRight: "10px",
																				paddingTop: "5px",
																				paragraphLineHeight: "29px",
																				paragraphLetterSpacing: "normal",
																				paragraphColor: "#141414",
																				paragraphFontSize: "16px",
																				paragraphFontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif",
																				linkTextDecoration: "underline",
																				linkColor: "#00c0e7",
																				h3LineHeight: "27px",
																				h3Color: "#000000",
																				h3FontSize: "22px",
																				h3FontFamily: "Georgia, Times, Times New Roman, serif",
																				h3LetterSpacing: "normal",
																				h2LineHeight: "34px",
																				h2Color: "#000000",
																				h2FontSize: "26px",
																				h2FontFamily: "Georgia, Times, Times New Roman, serif",
																				h2LetterSpacing: "normal",
																				h1LineHeight: "40px",
																				h1Color: "#000000",
																				h1FontSize: "33px",
																				h1FontFamily: "Georgia, Times, Times New Roman, serif",
																				h1LetterSpacing: "normal",
																				h6: {},
																				h5: {},
																				h4: {},
																			},
																			customData: null,
																		},
																	],
																	attrs: {
																		hideOnMobile: false,
																		hideOnDesktop: false,
																	},
																	style: {
																		backgroundColor: "",
																		backgroundRepeat: "no-repeat",
																		backgroundPosition: "center center",
																		backgroundImage: "",
																		backgroundSize: "auto",
																		borderRadius: "0px",
																		borderLeftColor: "#121212",
																		borderLeftStyle: "solid",
																		borderLeftWidth: "0px",
																		borderBottomColor: "#121212",
																		borderBottomStyle: "solid",
																		borderBottomWidth: "0px",
																		borderRightColor: "#121212",
																		borderRightStyle: "solid",
																		borderRightWidth: "0px",
																		borderTopColor: "#121212",
																		borderTopStyle: "solid",
																		borderTopWidth: "0px",
																		marginLeft: "10px",
																		marginBottom: "0px",
																		marginRight: "10px",
																		marginTop: "0px",
																		paddingLeft: "0px",
																		paddingBottom: "0px",
																		paddingRight: "0px",
																		paddingTop: "0px",
																	},
																	customData: {},
																},
																{
																	eid: "hyc0OQk3TG",
																	type: "text",
																	attrs: {
																		text: "<p style=\"text-align: center;\">FOUNDER</p>\n",
																	},
																	style: {
																		backgroundColor: "",
																		backgroundRepeat: "no-repeat",
																		backgroundPosition: "center center",
																		backgroundImage: "",
																		backgroundSize: "auto",
																		paddingLeft: "10px",
																		paddingBottom: "0px",
																		paddingRight: "10px",
																		paddingTop: "0px",
																		paragraphLineHeight: "25px",
																		paragraphLetterSpacing: "normal",
																		paragraphColor: {
																			reference: "PrimaryColor",
																			default: "#1762C5",
																		},
																		paragraphFontSize: "14px",
																		paragraphFontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif",
																		linkTextDecoration: "underline",
																		linkColor: "#00c0e7",
																		h3LineHeight: "27px",
																		h3Color: "#000000",
																		h3FontSize: "22px",
																		h3FontFamily: "Georgia, Times, Times New Roman, serif",
																		h3LetterSpacing: "normal",
																		h2LineHeight: "34px",
																		h2Color: "#000000",
																		h2FontSize: "26px",
																		h2FontFamily: "Georgia, Times, Times New Roman, serif",
																		h2LetterSpacing: "normal",
																		h1LineHeight: "40px",
																		h1Color: "#000000",
																		h1FontSize: "33px",
																		h1FontFamily: "Georgia, Times, Times New Roman, serif",
																		h1LetterSpacing: "normal",
																		h6: {},
																		h5: {},
																		h4: {},
																	},
																	customData: null,
																},
															],
															attrs: {
																hideOnMobile: false,
																hideOnDesktop: false,
															},
															style: {
																backgroundColor: "transparent",
																backgroundRepeat: "no-repeat",
																backgroundPosition: "center center",
																backgroundImage: "",
																backgroundSize: "auto",
																borderRadius: "0px",
																borderLeftColor: "#121212",
																borderLeftStyle: "solid",
																borderLeftWidth: "0px",
																borderBottomColor: "#121212",
																borderBottomStyle: "solid",
																borderBottomWidth: "0px",
																borderRightColor: "#121212",
																borderRightStyle: "solid",
																borderRightWidth: "0px",
																borderTopColor: "#121212",
																borderTopStyle: "solid",
																borderTopWidth: "0px",
																marginLeft: "0px",
																marginBottom: "0px",
																marginRight: "0px",
																marginTop: "0px",
																paddingLeft: "0px",
																paddingBottom: "10px",
																paddingRight: "0px",
																paddingTop: "0px",
															},
															customData: {},
														},
													],
													attrs: {
														hideOnMobile: false,
														lock: false,
													},
													style: {
														width: "290px",
														backgroundColor: "",
														backgroundRepeat: "no-repeat",
														backgroundPosition: "center center",
														backgroundImage: "",
														backgroundSize: "auto",
													},
													customData: {},
												},
											],
											attrs: {
												hideOnMobile: false,
												hideOnDesktop: false,
												stacking: "left-on-top",
												spacerBefore: "0px",
												spacerBetween: "0px",
												spacerAfter: "0px",
												spacerBeforeMobile: "0px",
												spacerBetweenMobile: "10px",
												spacerAfterMobile: "0px",
											},
											style: {
												backgroundColor: "",
												backgroundRepeat: "no-repeat",
												backgroundPosition: "center center",
												backgroundImage: "",
												backgroundSize: "auto",
											},
											customData: {},
										},
									],
									attrs: {
										hideOnMobile: false,
										hideOnDesktop: false,
									},
									style: {
										backgroundColor: "",
										backgroundRepeat: "no-repeat",
										backgroundPosition: "center center",
										backgroundImage: "",
										backgroundSize: "auto",
										borderRadius: "0px",
										borderLeftColor: "#121212",
										borderLeftStyle: "solid",
										borderLeftWidth: "0px",
										borderBottomColor: "#121212",
										borderBottomStyle: "solid",
										borderBottomWidth: "0px",
										borderRightColor: "#121212",
										borderRightStyle: "solid",
										borderRightWidth: "0px",
										borderTopColor: "#121212",
										borderTopStyle: "solid",
										borderTopWidth: "0px",
										marginLeft: "0px",
										marginBottom: "0px",
										marginRight: "0px",
										marginTop: "0px",
										paddingLeft: "0px",
										paddingBottom: "0px",
										paddingRight: "0px",
										paddingTop: "0px",
									},
									customData: {},
								},
							],
							attrs: {
								hideOnMobile: false,
								hideOnDesktop: false,
							},
							style: {
								backgroundColor: "transparent",
								backgroundRepeat: "no-repeat",
								backgroundPosition: "center center",
								backgroundImage: "https://chamaileon-sdk.github.io/example-jsons/assets/backgrounds/1602506297978_bg_business_abstract.png",
								backgroundSize: "auto",
								borderRadius: "0px",
								borderLeftColor: "#121212",
								borderLeftStyle: "solid",
								borderLeftWidth: "0px",
								borderBottomColor: "#121212",
								borderBottomStyle: "solid",
								borderBottomWidth: "0px",
								borderRightColor: "#121212",
								borderRightStyle: "solid",
								borderRightWidth: "0px",
								borderTopColor: "#121212",
								borderTopStyle: "solid",
								borderTopWidth: "0px",
								marginLeft: "0px",
								marginBottom: "0px",
								marginRight: "0px",
								marginTop: "0px",
								paddingLeft: "10px",
								paddingBottom: "5px",
								paddingRight: "10px",
								paddingTop: "30px",
							},
							customData: {},
						},
					],
					placeholder: [],
					attrs: {
						hideOnMobile: false,
						hideOnDesktop: false,
						lock: false,
						marker: "",
					},
					style: {
						backgroundColor: "",
						backgroundRepeat: "no-repeat",
						backgroundPosition: "center center",
						backgroundImage: "",
						backgroundSize: "auto",
						contentBackgroundColor: "#FFFFFF",
						contentBackgroundRepeat: "no-repeat",
						contentBackgroundPosition: "center center",
						contentBackgroundImage: "",
						contentBackgroundSize: "auto",
						contentBorderRadius: "0px",
						contentBorderLeftColor: "#121212",
						contentBorderLeftStyle: "solid",
						contentBorderLeftWidth: "0px",
						contentBorderBottomColor: "#121212",
						contentBorderBottomStyle: "solid",
						contentBorderBottomWidth: "0px",
						contentBorderRightColor: "#121212",
						contentBorderRightStyle: "solid",
						contentBorderRightWidth: "0px",
						contentBorderTopColor: "#121212",
						contentBorderTopStyle: "solid",
						contentBorderTopWidth: "0px",
						contentMarginLeft: "0px",
						contentMarginBottom: "0px",
						contentMarginRight: "0px",
						contentMarginTop: "0px",
						contentPaddingLeft: "0px",
						contentPaddingBottom: "0px",
						contentPaddingRight: "0px",
						contentPaddingTop: "0px",
						contentWidth: 600,
						bodyWidth: 600,
					},
					customData: {},
				},
				{
					eid: "VtzC8GNy9",
					type: "fullwidth",
					children: [
						{
							eid: "gX_Jf9I-2",
							type: "box",
							children: [
								{
									eid: "bk3y1eda-",
									type: "box",
									children: [
										{
											eid: "2CWwpBShPt",
											type: "multicolumn",
											children: [
												{
													eid: "aeop2V8xw0",
													type: "column",
													children: [
														{
															eid: "fPovuw8vlO",
															type: "box",
															children: [
																{
																	eid: "LNqn53Y40O",
																	type: "text",
																	attrs: {
																		text: "<p style=\"text-align: center;\"><b>Light</b></p>\n",
																	},
																	style: {
																		backgroundColor: "",
																		backgroundRepeat: "no-repeat",
																		backgroundPosition: "center center",
																		backgroundImage: "",
																		backgroundSize: "auto",
																		paddingLeft: "10px",
																		paddingBottom: "10px",
																		paddingRight: "10px",
																		paddingTop: "10px",
																		paragraphLineHeight: "25px",
																		paragraphLetterSpacing: "normal",
																		paragraphColor: {
																			reference: "PrimaryColor",
																			default: "#B6D2F6",
																		},
																		paragraphFontSize: "20px",
																		paragraphFontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif",
																		linkTextDecoration: "underline",
																		linkColor: "#58585a",
																		h3LineHeight: "22px",
																		h3Color: "#58585a",
																		h3FontSize: "22px",
																		h3FontFamily: "Helvetica, Helvetica Neue, Arial",
																		h3LetterSpacing: "normal",
																		h2LineHeight: "26px",
																		h2Color: "#58585a",
																		h2FontSize: "26px",
																		h2FontFamily: "Helvetica, Helvetica Neue, Arial",
																		h2LetterSpacing: "normal",
																		h1LineHeight: "32px",
																		h1Color: "#58585a",
																		h1FontSize: "32px",
																		h1FontFamily: "Helvetica, Helvetica Neue, Arial",
																		h1LetterSpacing: "normal",
																		h6: {
																			"line-height": "16px",
																			color: "#000000",
																			"font-size": "16px",
																			"font-family": "arial",
																		},
																		h5: {
																			"line-height": "18px",
																			color: "#000000",
																			"font-size": "18px",
																			"font-family": "arial",
																		},
																		h4: {
																			"line-height": "20px",
																			color: "#000000",
																			"font-size": "20px",
																			"font-family": "arial",
																		},
																	},
																	customData: null,
																},
																{
																	eid: "zrXJOIU524",
																	type: "box",
																	children: [
																		{
																			eid: "1sWBuKdw_V",
																			type: "text",
																			attrs: {
																				text: "<p style=\"text-align: center;\">Their Pronunciation and their most common words.</p>\n",
																			},
																			style: {
																				backgroundColor: "",
																				backgroundRepeat: "no-repeat",
																				backgroundPosition: "center center",
																				backgroundImage: "",
																				backgroundSize: "auto",
																				paddingLeft: "10px",
																				paddingBottom: "5px",
																				paddingRight: "10px",
																				paddingTop: "10px",
																				paragraphLineHeight: "18px",
																				paragraphLetterSpacing: "normal",
																				paragraphColor: {
																					reference: "SecondaryColor",
																					default: "#5C9AEB",
																				},
																				paragraphFontSize: "13px",
																				paragraphFontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif",
																				linkTextDecoration: "none",
																				linkColor: "#165bb4",
																				h3LineHeight: "22px",
																				h3Color: "#a7a7a7",
																				h3FontSize: "22px",
																				h3FontFamily: "Helvetica, Helvetica Neue, Arial",
																				h3LetterSpacing: "normal",
																				h2LineHeight: "26px",
																				h2Color: "#a7a7a7",
																				h2FontSize: "26px",
																				h2FontFamily: "Helvetica, Helvetica Neue, Arial",
																				h2LetterSpacing: "normal",
																				h1LineHeight: "32px",
																				h1Color: "#a7a7a7",
																				h1FontSize: "32px",
																				h1FontFamily: "Helvetica, Helvetica Neue, Arial",
																				h1LetterSpacing: "normal",
																				h6: {
																					"line-height": "16px",
																					color: "#000000",
																					"font-size": "16px",
																					"font-family": "arial",
																				},
																				h5: {
																					"line-height": "18px",
																					color: "#000000",
																					"font-size": "18px",
																					"font-family": "arial",
																				},
																				h4: {
																					"line-height": "20px",
																					color: "#000000",
																					"font-size": "20px",
																					"font-family": "arial",
																				},
																			},
																			customData: null,
																		},
																		{
																			eid: "DspJSEDO94",
																			type: "text",
																			attrs: {
																				text: "<p style=\"text-align: center;\"><strong>$16.00</strong></p>",
																			},
																			style: {
																				backgroundColor: "",
																				backgroundRepeat: "no-repeat",
																				backgroundPosition: "center center",
																				backgroundImage: "",
																				backgroundSize: "auto",
																				paddingLeft: "5px",
																				paddingBottom: "15px",
																				paddingRight: "5px",
																				paddingTop: "5px",
																				paragraphLineHeight: "32px",
																				paragraphLetterSpacing: "normal",
																				paragraphColor: {
																					reference: "PrimaryColor",
																					default: "#165BB4",
																				},
																				paragraphFontSize: "32px",
																				paragraphFontFamily: "Helvetica, Helvetica Neue, Arial",
																				linkTextDecoration: "underline",
																				linkColor: "#ffffff",
																				h3LineHeight: "22px",
																				h3Color: "#ffffff",
																				h3FontSize: "22px",
																				h3FontFamily: "Helvetica, Helvetica Neue, Arial",
																				h3LetterSpacing: "normal",
																				h2LineHeight: "26px",
																				h2Color: "#ffffff",
																				h2FontSize: "26px",
																				h2FontFamily: "Helvetica, Helvetica Neue, Arial",
																				h2LetterSpacing: "normal",
																				h1LineHeight: "32px",
																				h1Color: "#ffffff",
																				h1FontSize: "32px",
																				h1FontFamily: "Helvetica, Helvetica Neue, Arial",
																				h1LetterSpacing: "normal",
																				h6: {
																					"line-height": "16px",
																					color: "#000000",
																					"font-size": "16px",
																					"font-family": "arial",
																				},
																				h5: {
																					"line-height": "18px",
																					color: "#000000",
																					"font-size": "18px",
																					"font-family": "arial",
																				},
																				h4: {
																					"line-height": "20px",
																					color: "#000000",
																					"font-size": "20px",
																					"font-family": "arial",
																				},
																			},
																			customData: null,
																		},
																	],
																	attrs: {
																		hideOnMobile: false,
																		hideOnDesktop: false,
																	},
																	style: {
																		backgroundColor: "#EDF4FD",
																		backgroundRepeat: "no-repeat",
																		backgroundPosition: "center center",
																		backgroundImage: "",
																		backgroundSize: "auto",
																		borderRadius: "3px",
																		borderLeftColor: "#B6D2F6",
																		borderLeftStyle: "solid",
																		borderLeftWidth: "0px",
																		borderBottomColor: "#B6D2F6",
																		borderBottomStyle: "solid",
																		borderBottomWidth: "0px",
																		borderRightColor: "#B6D2F6",
																		borderRightStyle: "solid",
																		borderRightWidth: "0px",
																		borderTopColor: "#B6D2F6",
																		borderTopStyle: "solid",
																		borderTopWidth: "0px",
																		marginLeft: "10px",
																		marginBottom: "10px",
																		marginRight: "10px",
																		marginTop: "10px",
																		paddingLeft: "0px",
																		paddingBottom: "5px",
																		paddingRight: "0px",
																		paddingTop: "5px",
																	},
																	customData: {},
																},
																{
																	eid: "AOW7_PU8FA",
																	type: "button",
																	attrs: {
																		title: "",
																		text: "<p>Shop Now</p>\n",
																		href: "",
																	},
																	style: {
																		lineHeight: "24px",
																		color: "#ffffff",
																		fontSize: "17px",
																		fontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif",
																		letterSpacing: "normal",
																		backgroundColor: {
																			reference: "PrimaryColor",
																			default: "#165BB4",
																		},
																		backgroundRepeat: "no-repeat",
																		backgroundPosition: "center center",
																		backgroundImage: "",
																		backgroundSize: "auto",
																		borderRadius: "5px",
																		borderLeftColor: "#121212",
																		borderLeftStyle: "solid",
																		borderLeftWidth: "0px",
																		borderBottomColor: "#121212",
																		borderBottomStyle: "solid",
																		borderBottomWidth: "0px",
																		borderRightColor: "#121212",
																		borderRightStyle: "solid",
																		borderRightWidth: "0px",
																		borderTopColor: "#121212",
																		borderTopStyle: "solid",
																		borderTopWidth: "0px",
																		marginLeft: "10px",
																		marginBottom: "20px",
																		marginRight: "10px",
																		marginTop: "20px",
																		paddingLeft: "25px",
																		paddingBottom: "9px",
																		paddingRight: "25px",
																		paddingTop: "9px",
																		hoverBackgroundColor: "",
																		sizeType: "FIT_TO_TEXT",
																		fullWidthOnMobile: false,
																		align: "center",
																	},
																	customData: null,
																},
															],
															attrs: {
																hideOnMobile: false,
																hideOnDesktop: false,
															},
															style: {
																backgroundColor: "",
																backgroundRepeat: "no-repeat",
																backgroundPosition: "center center",
																backgroundImage: "",
																backgroundSize: "auto",
																borderRadius: "0px",
																borderLeftColor: "#121212",
																borderLeftStyle: "solid",
																borderLeftWidth: "0px",
																borderBottomColor: "#121212",
																borderBottomStyle: "solid",
																borderBottomWidth: "0px",
																borderRightColor: "#121212",
																borderRightStyle: "solid",
																borderRightWidth: "0px",
																borderTopColor: "#121212",
																borderTopStyle: "solid",
																borderTopWidth: "0px",
																marginLeft: "0px",
																marginBottom: "0px",
																marginRight: "0px",
																marginTop: "0px",
																paddingLeft: "0px",
																paddingBottom: "0px",
																paddingRight: "0px",
																paddingTop: "0px",
															},
															customData: {},
														},
													],
													attrs: {
														hideOnMobile: false,
														lock: false,
													},
													style: {
														width: "193.33333333333334px",
														backgroundColor: "",
														backgroundRepeat: "no-repeat",
														backgroundPosition: "center center",
														backgroundImage: "",
														backgroundSize: "auto",
													},
													customData: {},
												},
												{
													eid: "mORJX2NSK9",
													type: "column",
													children: [
														{
															eid: "FmdaqnttUg",
															type: "box",
															children: [
																{
																	eid: "rMAQtiQATg",
																	type: "text",
																	attrs: {
																		text: "<p style=\"text-align: center;\"><b>Medium</b></p>\n",
																	},
																	style: {
																		backgroundColor: "",
																		backgroundRepeat: "no-repeat",
																		backgroundPosition: "center center",
																		backgroundImage: "",
																		backgroundSize: "auto",
																		paddingLeft: "10px",
																		paddingBottom: "10px",
																		paddingRight: "10px",
																		paddingTop: "10px",
																		paragraphLineHeight: "25px",
																		paragraphLetterSpacing: "normal",
																		paragraphColor: {
																			reference: "PrimaryColor",
																			default: "#5C9AEB",
																		},
																		paragraphFontSize: "20px",
																		paragraphFontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif",
																		linkTextDecoration: "underline",
																		linkColor: "#58585a",
																		h3LineHeight: "22px",
																		h3Color: "#58585a",
																		h3FontSize: "22px",
																		h3FontFamily: "Helvetica, Helvetica Neue, Arial",
																		h3LetterSpacing: "normal",
																		h2LineHeight: "26px",
																		h2Color: "#58585a",
																		h2FontSize: "26px",
																		h2FontFamily: "Helvetica, Helvetica Neue, Arial",
																		h2LetterSpacing: "normal",
																		h1LineHeight: "32px",
																		h1Color: "#58585a",
																		h1FontSize: "32px",
																		h1FontFamily: "Helvetica, Helvetica Neue, Arial",
																		h1LetterSpacing: "normal",
																		h6: {
																			"line-height": "16px",
																			color: "#000000",
																			"font-size": "16px",
																			"font-family": "arial",
																		},
																		h5: {
																			"line-height": "18px",
																			color: "#000000",
																			"font-size": "18px",
																			"font-family": "arial",
																		},
																		h4: {
																			"line-height": "20px",
																			color: "#000000",
																			"font-size": "20px",
																			"font-family": "arial",
																		},
																	},
																	customData: null,
																},
																{
																	eid: "t9nCkWPhac",
																	type: "box",
																	children: [
																		{
																			eid: "U2bTZqZGBc",
																			type: "text",
																			attrs: {
																				text: "<p style=\"text-align: center;\">Their Pronunciation and their most common words.</p>\n",
																			},
																			style: {
																				backgroundColor: "",
																				backgroundRepeat: "no-repeat",
																				backgroundPosition: "center center",
																				backgroundImage: "",
																				backgroundSize: "auto",
																				paddingLeft: "10px",
																				paddingBottom: "5px",
																				paddingRight: "10px",
																				paddingTop: "10px",
																				paragraphLineHeight: "18px",
																				paragraphLetterSpacing: "normal",
																				paragraphColor: {
																					reference: "SecondaryColor",
																					default: "#5C9AEB",
																				},
																				paragraphFontSize: "13px",
																				paragraphFontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif",
																				linkTextDecoration: "none",
																				linkColor: "#165bb4",
																				h3LineHeight: "22px",
																				h3Color: "#a7a7a7",
																				h3FontSize: "22px",
																				h3FontFamily: "Helvetica, Helvetica Neue, Arial",
																				h3LetterSpacing: "normal",
																				h2LineHeight: "26px",
																				h2Color: "#a7a7a7",
																				h2FontSize: "26px",
																				h2FontFamily: "Helvetica, Helvetica Neue, Arial",
																				h2LetterSpacing: "normal",
																				h1LineHeight: "32px",
																				h1Color: "#a7a7a7",
																				h1FontSize: "32px",
																				h1FontFamily: "Helvetica, Helvetica Neue, Arial",
																				h1LetterSpacing: "normal",
																				h6: {
																					"line-height": "16px",
																					color: "#000000",
																					"font-size": "16px",
																					"font-family": "arial",
																				},
																				h5: {
																					"line-height": "18px",
																					color: "#000000",
																					"font-size": "18px",
																					"font-family": "arial",
																				},
																				h4: {
																					"line-height": "20px",
																					color: "#000000",
																					"font-size": "20px",
																					"font-family": "arial",
																				},
																			},
																			customData: null,
																		},
																		{
																			eid: "87uACi154kk",
																			type: "text",
																			attrs: {
																				text: "<p style=\"text-align: center;\"><strong>$16.00</strong></p>",
																			},
																			style: {
																				backgroundColor: "",
																				backgroundRepeat: "no-repeat",
																				backgroundPosition: "center center",
																				backgroundImage: "",
																				backgroundSize: "auto",
																				paddingLeft: "5px",
																				paddingBottom: "15px",
																				paddingRight: "5px",
																				paddingTop: "5px",
																				paragraphLineHeight: "32px",
																				paragraphLetterSpacing: "normal",
																				paragraphColor: {
																					reference: "PrimaryColor",
																					default: "#165BB4",
																				},
																				paragraphFontSize: "32px",
																				paragraphFontFamily: "Helvetica, Helvetica Neue, Arial",
																				linkTextDecoration: "underline",
																				linkColor: "#ffffff",
																				h3LineHeight: "22px",
																				h3Color: "#ffffff",
																				h3FontSize: "22px",
																				h3FontFamily: "Helvetica, Helvetica Neue, Arial",
																				h3LetterSpacing: "normal",
																				h2LineHeight: "26px",
																				h2Color: "#ffffff",
																				h2FontSize: "26px",
																				h2FontFamily: "Helvetica, Helvetica Neue, Arial",
																				h2LetterSpacing: "normal",
																				h1LineHeight: "32px",
																				h1Color: "#ffffff",
																				h1FontSize: "32px",
																				h1FontFamily: "Helvetica, Helvetica Neue, Arial",
																				h1LetterSpacing: "normal",
																				h6: {
																					"line-height": "16px",
																					color: "#000000",
																					"font-size": "16px",
																					"font-family": "arial",
																				},
																				h5: {
																					"line-height": "18px",
																					color: "#000000",
																					"font-size": "18px",
																					"font-family": "arial",
																				},
																				h4: {
																					"line-height": "20px",
																					color: "#000000",
																					"font-size": "20px",
																					"font-family": "arial",
																				},
																			},
																			customData: null,
																		},
																	],
																	attrs: {
																		hideOnMobile: false,
																		hideOnDesktop: false,
																	},
																	style: {
																		backgroundColor: "#EDF4FD",
																		backgroundRepeat: "no-repeat",
																		backgroundPosition: "center center",
																		backgroundImage: "",
																		backgroundSize: "auto",
																		borderRadius: "3px",
																		borderLeftColor: "#B6D2F6",
																		borderLeftStyle: "solid",
																		borderLeftWidth: "0px",
																		borderBottomColor: "#B6D2F6",
																		borderBottomStyle: "solid",
																		borderBottomWidth: "0px",
																		borderRightColor: "#B6D2F6",
																		borderRightStyle: "solid",
																		borderRightWidth: "0px",
																		borderTopColor: "#B6D2F6",
																		borderTopStyle: "solid",
																		borderTopWidth: "0px",
																		marginLeft: "10px",
																		marginBottom: "10px",
																		marginRight: "10px",
																		marginTop: "10px",
																		paddingLeft: "0px",
																		paddingBottom: "5px",
																		paddingRight: "0px",
																		paddingTop: "5px",
																	},
																	customData: {},
																},
																{
																	eid: "iGCjdAHNPc1",
																	type: "button",
																	attrs: {
																		title: "",
																		text: "<p>Shop Now</p>\n",
																		href: "",
																	},
																	style: {
																		lineHeight: "24px",
																		color: "#ffffff",
																		fontSize: "17px",
																		fontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif",
																		letterSpacing: "normal",
																		backgroundColor: {
																			reference: "PrimaryColor",
																			default: "#165BB4",
																		},
																		backgroundRepeat: "no-repeat",
																		backgroundPosition: "center center",
																		backgroundImage: "",
																		backgroundSize: "auto",
																		borderRadius: "5px",
																		borderLeftColor: "#121212",
																		borderLeftStyle: "solid",
																		borderLeftWidth: "0px",
																		borderBottomColor: "#121212",
																		borderBottomStyle: "solid",
																		borderBottomWidth: "0px",
																		borderRightColor: "#121212",
																		borderRightStyle: "solid",
																		borderRightWidth: "0px",
																		borderTopColor: "#121212",
																		borderTopStyle: "solid",
																		borderTopWidth: "0px",
																		marginLeft: "10px",
																		marginBottom: "20px",
																		marginRight: "10px",
																		marginTop: "20px",
																		paddingLeft: "25px",
																		paddingBottom: "9px",
																		paddingRight: "25px",
																		paddingTop: "9px",
																		hoverBackgroundColor: "",
																		sizeType: "FIT_TO_TEXT",
																		fullWidthOnMobile: false,
																		align: "center",
																	},
																	customData: null,
																},
															],
															attrs: {
																hideOnMobile: false,
																hideOnDesktop: false,
															},
															style: {
																backgroundColor: "",
																backgroundRepeat: "no-repeat",
																backgroundPosition: "center center",
																backgroundImage: "",
																backgroundSize: "auto",
																borderRadius: "0px",
																borderLeftColor: "#121212",
																borderLeftStyle: "solid",
																borderLeftWidth: "0px",
																borderBottomColor: "#121212",
																borderBottomStyle: "solid",
																borderBottomWidth: "0px",
																borderRightColor: "#121212",
																borderRightStyle: "solid",
																borderRightWidth: "0px",
																borderTopColor: "#121212",
																borderTopStyle: "solid",
																borderTopWidth: "0px",
																marginLeft: "0px",
																marginBottom: "0px",
																marginRight: "0px",
																marginTop: "0px",
																paddingLeft: "0px",
																paddingBottom: "0px",
																paddingRight: "0px",
																paddingTop: "0px",
															},
															customData: {},
														},
													],
													attrs: {
														hideOnMobile: false,
														lock: false,
													},
													style: {
														width: "193.33333333333334px",
														backgroundColor: "",
														backgroundRepeat: "no-repeat",
														backgroundPosition: "center center",
														backgroundImage: "",
														backgroundSize: "auto",
													},
													customData: {},
												},
												{
													eid: "ifwRspl_ILP",
													type: "column",
													children: [
														{
															eid: "GmMrp_MB1c3",
															type: "box",
															children: [
																{
																	eid: "4hFdp3DDrxG",
																	type: "text",
																	attrs: {
																		text: "<p style=\"text-align: center;\"><b>Strong</b></p>\n",
																	},
																	style: {
																		backgroundColor: "",
																		backgroundRepeat: "no-repeat",
																		backgroundPosition: "center center",
																		backgroundImage: "",
																		backgroundSize: "auto",
																		paddingLeft: "10px",
																		paddingBottom: "10px",
																		paddingRight: "10px",
																		paddingTop: "10px",
																		paragraphLineHeight: "25px",
																		paragraphLetterSpacing: "normal",
																		paragraphColor: {
																			reference: "PrimaryColor",
																			default: "#165BB4",
																		},
																		paragraphFontSize: "20px",
																		paragraphFontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif",
																		linkTextDecoration: "underline",
																		linkColor: "#58585a",
																		h3LineHeight: "22px",
																		h3Color: "#58585a",
																		h3FontSize: "22px",
																		h3FontFamily: "Helvetica, Helvetica Neue, Arial",
																		h3LetterSpacing: "normal",
																		h2LineHeight: "26px",
																		h2Color: "#58585a",
																		h2FontSize: "26px",
																		h2FontFamily: "Helvetica, Helvetica Neue, Arial",
																		h2LetterSpacing: "normal",
																		h1LineHeight: "32px",
																		h1Color: "#58585a",
																		h1FontSize: "32px",
																		h1FontFamily: "Helvetica, Helvetica Neue, Arial",
																		h1LetterSpacing: "normal",
																		h6: {
																			"line-height": "16px",
																			color: "#000000",
																			"font-size": "16px",
																			"font-family": "arial",
																		},
																		h5: {
																			"line-height": "18px",
																			color: "#000000",
																			"font-size": "18px",
																			"font-family": "arial",
																		},
																		h4: {
																			"line-height": "20px",
																			color: "#000000",
																			"font-size": "20px",
																			"font-family": "arial",
																		},
																	},
																	customData: null,
																},
																{
																	eid: "Rfh3vJTb0BP",
																	type: "box",
																	children: [
																		{
																			eid: "CrSorptBYOs",
																			type: "text",
																			attrs: {
																				text: "<p style=\"text-align: center;\">Their Pronunciation and their most common words.</p>\n",
																			},
																			style: {
																				backgroundColor: "",
																				backgroundRepeat: "no-repeat",
																				backgroundPosition: "center center",
																				backgroundImage: "",
																				backgroundSize: "auto",
																				paddingLeft: "10px",
																				paddingBottom: "5px",
																				paddingRight: "10px",
																				paddingTop: "10px",
																				paragraphLineHeight: "18px",
																				paragraphLetterSpacing: "normal",
																				paragraphColor: {
																					reference: "SecondaryColor",
																					default: "#5C9AEB",
																				},
																				paragraphFontSize: "13px",
																				paragraphFontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif",
																				linkTextDecoration: "none",
																				linkColor: "#165bb4",
																				h3LineHeight: "22px",
																				h3Color: "#a7a7a7",
																				h3FontSize: "22px",
																				h3FontFamily: "Helvetica, Helvetica Neue, Arial",
																				h3LetterSpacing: "normal",
																				h2LineHeight: "26px",
																				h2Color: "#a7a7a7",
																				h2FontSize: "26px",
																				h2FontFamily: "Helvetica, Helvetica Neue, Arial",
																				h2LetterSpacing: "normal",
																				h1LineHeight: "32px",
																				h1Color: "#a7a7a7",
																				h1FontSize: "32px",
																				h1FontFamily: "Helvetica, Helvetica Neue, Arial",
																				h1LetterSpacing: "normal",
																				h6: {
																					"line-height": "16px",
																					color: "#000000",
																					"font-size": "16px",
																					"font-family": "arial",
																				},
																				h5: {
																					"line-height": "18px",
																					color: "#000000",
																					"font-size": "18px",
																					"font-family": "arial",
																				},
																				h4: {
																					"line-height": "20px",
																					color: "#000000",
																					"font-size": "20px",
																					"font-family": "arial",
																				},
																			},
																			customData: null,
																		},
																		{
																			eid: "SEsswitxOXt",
																			type: "text",
																			attrs: {
																				text: "<p style=\"text-align: center;\"><strong>$16.00</strong></p>",
																			},
																			style: {
																				backgroundColor: "",
																				backgroundRepeat: "no-repeat",
																				backgroundPosition: "center center",
																				backgroundImage: "",
																				backgroundSize: "auto",
																				paddingLeft: "5px",
																				paddingBottom: "15px",
																				paddingRight: "5px",
																				paddingTop: "5px",
																				paragraphLineHeight: "32px",
																				paragraphLetterSpacing: "normal",
																				paragraphColor: {
																					reference: "PrimaryColor",
																					default: "#165BB4",
																				},
																				paragraphFontSize: "32px",
																				paragraphFontFamily: "Helvetica, Helvetica Neue, Arial",
																				linkTextDecoration: "underline",
																				linkColor: "#ffffff",
																				h3LineHeight: "22px",
																				h3Color: "#ffffff",
																				h3FontSize: "22px",
																				h3FontFamily: "Helvetica, Helvetica Neue, Arial",
																				h3LetterSpacing: "normal",
																				h2LineHeight: "26px",
																				h2Color: "#ffffff",
																				h2FontSize: "26px",
																				h2FontFamily: "Helvetica, Helvetica Neue, Arial",
																				h2LetterSpacing: "normal",
																				h1LineHeight: "32px",
																				h1Color: "#ffffff",
																				h1FontSize: "32px",
																				h1FontFamily: "Helvetica, Helvetica Neue, Arial",
																				h1LetterSpacing: "normal",
																				h6: {
																					"line-height": "16px",
																					color: "#000000",
																					"font-size": "16px",
																					"font-family": "arial",
																				},
																				h5: {
																					"line-height": "18px",
																					color: "#000000",
																					"font-size": "18px",
																					"font-family": "arial",
																				},
																				h4: {
																					"line-height": "20px",
																					color: "#000000",
																					"font-size": "20px",
																					"font-family": "arial",
																				},
																			},
																			customData: null,
																		},
																	],
																	attrs: {
																		hideOnMobile: false,
																		hideOnDesktop: false,
																	},
																	style: {
																		backgroundColor: "#EDF4FD",
																		backgroundRepeat: "no-repeat",
																		backgroundPosition: "center center",
																		backgroundImage: "",
																		backgroundSize: "auto",
																		borderRadius: "3px",
																		borderLeftColor: "#B6D2F6",
																		borderLeftStyle: "solid",
																		borderLeftWidth: "0px",
																		borderBottomColor: "#B6D2F6",
																		borderBottomStyle: "solid",
																		borderBottomWidth: "0px",
																		borderRightColor: "#B6D2F6",
																		borderRightStyle: "solid",
																		borderRightWidth: "0px",
																		borderTopColor: "#B6D2F6",
																		borderTopStyle: "solid",
																		borderTopWidth: "0px",
																		marginLeft: "10px",
																		marginBottom: "10px",
																		marginRight: "10px",
																		marginTop: "10px",
																		paddingLeft: "0px",
																		paddingBottom: "5px",
																		paddingRight: "0px",
																		paddingTop: "5px",
																	},
																	customData: {},
																},
																{
																	eid: "aNuzXF3O05C",
																	type: "button",
																	attrs: {
																		title: "",
																		text: "<p>Shop Now</p>\n",
																		href: "",
																	},
																	style: {
																		lineHeight: "24px",
																		color: "#ffffff",
																		fontSize: "17px",
																		fontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif",
																		letterSpacing: "normal",
																		backgroundColor: {
																			reference: "PrimaryColor",
																			default: "#165BB4",
																		},
																		backgroundRepeat: "no-repeat",
																		backgroundPosition: "center center",
																		backgroundImage: "",
																		backgroundSize: "auto",
																		borderRadius: "5px",
																		borderLeftColor: "#121212",
																		borderLeftStyle: "solid",
																		borderLeftWidth: "0px",
																		borderBottomColor: "#121212",
																		borderBottomStyle: "solid",
																		borderBottomWidth: "0px",
																		borderRightColor: "#121212",
																		borderRightStyle: "solid",
																		borderRightWidth: "0px",
																		borderTopColor: "#121212",
																		borderTopStyle: "solid",
																		borderTopWidth: "0px",
																		marginLeft: "10px",
																		marginBottom: "20px",
																		marginRight: "10px",
																		marginTop: "20px",
																		paddingLeft: "25px",
																		paddingBottom: "9px",
																		paddingRight: "25px",
																		paddingTop: "9px",
																		hoverBackgroundColor: "",
																		sizeType: "FIT_TO_TEXT",
																		fullWidthOnMobile: false,
																		align: "center",
																	},
																	customData: null,
																},
															],
															attrs: {
																hideOnMobile: false,
																hideOnDesktop: false,
															},
															style: {
																backgroundColor: "",
																backgroundRepeat: "no-repeat",
																backgroundPosition: "center center",
																backgroundImage: "",
																backgroundSize: "auto",
																borderRadius: "0px",
																borderLeftColor: "#121212",
																borderLeftStyle: "solid",
																borderLeftWidth: "0px",
																borderBottomColor: "#121212",
																borderBottomStyle: "solid",
																borderBottomWidth: "0px",
																borderRightColor: "#121212",
																borderRightStyle: "solid",
																borderRightWidth: "0px",
																borderTopColor: "#121212",
																borderTopStyle: "solid",
																borderTopWidth: "0px",
																marginLeft: "0px",
																marginBottom: "0px",
																marginRight: "0px",
																marginTop: "0px",
																paddingLeft: "0px",
																paddingBottom: "0px",
																paddingRight: "0px",
																paddingTop: "0px",
															},
															customData: {},
														},
													],
													attrs: {
														hideOnMobile: false,
														lock: false,
													},
													style: {
														width: "193.33333333333334px",
														backgroundColor: "",
														backgroundRepeat: "no-repeat",
														backgroundPosition: "center center",
														backgroundImage: "",
														backgroundSize: "auto",
													},
													customData: {},
												},
											],
											attrs: {
												hideOnMobile: false,
												hideOnDesktop: false,
												stacking: "left-on-top",
												spacerBefore: "0px",
												spacerBetween: "0px",
												spacerAfter: "0px",
												spacerBeforeMobile: "0px",
												spacerBetweenMobile: "10px",
												spacerAfterMobile: "0px",
											},
											style: {
												backgroundColor: "",
												backgroundRepeat: "no-repeat",
												backgroundPosition: "center center",
												backgroundImage: "",
												backgroundSize: "auto",
											},
											customData: {},
										},
									],
									attrs: {
										hideOnMobile: false,
										hideOnDesktop: false,
									},
									style: {
										backgroundColor: "",
										backgroundRepeat: "no-repeat",
										backgroundPosition: "center top",
										backgroundImage: "https://chamaileon-sdk.github.io/example-jsons/assets/backgrounds/1602506297978_bg_business_abstract.png",
										backgroundSize: "auto",
										borderRadius: "0px",
										borderLeftColor: "#121212",
										borderLeftStyle: "solid",
										borderLeftWidth: "0px",
										borderBottomColor: "#121212",
										borderBottomStyle: "solid",
										borderBottomWidth: "0px",
										borderRightColor: "#121212",
										borderRightStyle: "solid",
										borderRightWidth: "0px",
										borderTopColor: "#121212",
										borderTopStyle: "solid",
										borderTopWidth: "0px",
										marginLeft: "0px",
										marginBottom: "0px",
										marginRight: "0px",
										marginTop: "0px",
										paddingLeft: "10px",
										paddingBottom: "5px",
										paddingRight: "10px",
										paddingTop: "5px",
									},
									customData: {},
								},
							],
							attrs: {
								hideOnMobile: false,
								hideOnDesktop: false,
							},
							style: {
								backgroundColor: "",
								backgroundRepeat: "no-repeat",
								backgroundPosition: "center center",
								backgroundImage: "",
								backgroundSize: "auto",
								borderRadius: "0px",
								borderLeftColor: "#121212",
								borderLeftStyle: "solid",
								borderLeftWidth: "0px",
								borderBottomColor: "#121212",
								borderBottomStyle: "solid",
								borderBottomWidth: "0px",
								borderRightColor: "#121212",
								borderRightStyle: "solid",
								borderRightWidth: "0px",
								borderTopColor: "#121212",
								borderTopStyle: "solid",
								borderTopWidth: "0px",
								marginLeft: "0px",
								marginBottom: "0px",
								marginRight: "0px",
								marginTop: "0px",
								paddingLeft: "0px",
								paddingBottom: "0px",
								paddingRight: "0px",
								paddingTop: "0px",
							},
							customData: {},
						},
					],
					placeholder: [],
					attrs: {
						hideOnMobile: false,
						hideOnDesktop: false,
						lock: false,
						marker: "",
					},
					style: {
						backgroundColor: "",
						backgroundRepeat: "no-repeat",
						backgroundPosition: "center center",
						backgroundImage: "",
						backgroundSize: "auto",
						contentBackgroundColor: "#FFFFFF",
						contentBackgroundRepeat: "no-repeat",
						contentBackgroundPosition: "center top",
						contentBackgroundImage: "",
						contentBackgroundSize: "auto",
						contentBorderRadius: "0px",
						contentBorderLeftColor: "#121212",
						contentBorderLeftStyle: "solid",
						contentBorderLeftWidth: "0px",
						contentBorderBottomColor: "#121212",
						contentBorderBottomStyle: "solid",
						contentBorderBottomWidth: "0px",
						contentBorderRightColor: "#121212",
						contentBorderRightStyle: "solid",
						contentBorderRightWidth: "0px",
						contentBorderTopColor: "#121212",
						contentBorderTopStyle: "solid",
						contentBorderTopWidth: "0px",
						contentMarginLeft: "0px",
						contentMarginBottom: "0px",
						contentMarginRight: "0px",
						contentMarginTop: "0px",
						contentPaddingLeft: "0px",
						contentPaddingBottom: "0px",
						contentPaddingRight: "0px",
						contentPaddingTop: "0px",
						contentWidth: 600,
						bodyWidth: 600,
					},
					customData: {},
				},
				{
					eid: "uix55AC0m",
					type: "fullwidth",
					children: [
						{
							eid: "wMFojbe7LG",
							type: "multicolumn",
							children: [
								{
									eid: "oWxcJmZFb8",
									type: "column",
									children: [
										{
											eid: "6nfRRJyOW",
											type: "text",
											attrs: {
												text: "<p style=\"text-align: center;\">THEIR PRONUNCIATION AND THEIR MOST COMMON WORDS.</p>\n",
											},
											style: {
												backgroundColor: "",
												backgroundRepeat: "no-repeat",
												backgroundPosition: "center center",
												backgroundImage: "",
												backgroundSize: "auto",
												paddingLeft: "10px",
												paddingBottom: "15px",
												paddingRight: "10px",
												paddingTop: "10px",
												paragraphLineHeight: "20px",
												paragraphLetterSpacing: "normal",
												paragraphColor: "#FFFFFF",
												paragraphFontSize: "13px",
												paragraphFontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif",
												linkTextDecoration: "none",
												linkColor: "#165bb4",
												h3LineHeight: "22px",
												h3Color: "#a7a7a7",
												h3FontSize: "22px",
												h3FontFamily: "Helvetica, Helvetica Neue, Arial",
												h3LetterSpacing: "normal",
												h2LineHeight: "26px",
												h2Color: "#a7a7a7",
												h2FontSize: "26px",
												h2FontFamily: "Helvetica, Helvetica Neue, Arial",
												h2LetterSpacing: "normal",
												h1LineHeight: "32px",
												h1Color: "#a7a7a7",
												h1FontSize: "32px",
												h1FontFamily: "Helvetica, Helvetica Neue, Arial",
												h1LetterSpacing: "normal",
												h6: {
													"line-height": "16px",
													color: "#000000",
													"font-size": "16px",
													"font-family": "arial",
												},
												h5: {
													"line-height": "18px",
													color: "#000000",
													"font-size": "18px",
													"font-family": "arial",
												},
												h4: {
													"line-height": "20px",
													color: "#000000",
													"font-size": "20px",
													"font-family": "arial",
												},
											},
											customData: null,
										},
									],
									attrs: {
										hideOnMobile: false,
										lock: false,
									},
									style: {
										width: "272.99999999999994px",
										backgroundColor: "",
										backgroundRepeat: "no-repeat",
										backgroundPosition: "center center",
										backgroundImage: "",
										backgroundSize: "auto",
									},
									customData: {},
								},
								{
									eid: "qx-eGT6eQu",
									type: "column",
									children: [
										{
											eid: "B48PFF-wQ",
											type: "box",
											children: [
												{
													eid: "_eUOeFfei",
													type: "multicolumn",
													children: [
														{
															eid: "QtLvVHQ7t3",
															type: "column",
															children: [
																{
																	eid: "HhNac7fLo",
																	type: "image",
																	attrs: {
																		title: "",
																		link: "",
																		altText: "",
																		src: "https://chamaileon-sdk.github.io/example-jsons/assets/social-icons/ig-3-grey.png",
																	},
																	style: {
																		fullWidthOnMobile: false,
																		align: "center",
																		lockedWidth: null,
																		lockedHeight: null,
																		maxHeight: "240px",
																		maxWidth: "240px",
																		width: "32px",
																		backgroundColor: "",
																		backgroundRepeat: "no-repeat",
																		backgroundPosition: "center center",
																		backgroundImage: "",
																		backgroundSize: "auto",
																		borderRadius: "0px",
																		borderLeftColor: "#121212",
																		borderLeftStyle: "solid",
																		borderLeftWidth: "0px",
																		borderBottomColor: "#121212",
																		borderBottomStyle: "solid",
																		borderBottomWidth: "0px",
																		borderRightColor: "#121212",
																		borderRightStyle: "solid",
																		borderRightWidth: "0px",
																		borderTopColor: "#121212",
																		borderTopStyle: "solid",
																		borderTopWidth: "0px",
																		marginLeft: "0px",
																		marginBottom: "0px",
																		marginRight: "0px",
																		marginTop: "0px",
																		paddingLeft: "0px",
																		paddingBottom: "0px",
																		paddingRight: "0px",
																		paddingTop: "0px",
																	},
																	customData: null,
																},
															],
															attrs: {
																hideOnMobile: false,
																lock: false,
															},
															style: {
																width: "47.833333333333336px",
																backgroundColor: "",
																backgroundRepeat: "no-repeat",
																backgroundPosition: "center center",
																backgroundImage: "",
																backgroundSize: "auto",
															},
															customData: {},
														},
														{
															eid: "KJ_afldsr",
															type: "column",
															children: [
																{
																	eid: "bFphMfPDBy",
																	type: "image",
																	attrs: {
																		title: "",
																		link: "",
																		altText: "",
																		src: "https://chamaileon-sdk.github.io/example-jsons/assets/social-icons/fb-3-grey.png",
																	},
																	style: {
																		fullWidthOnMobile: false,
																		align: "center",
																		lockedWidth: null,
																		lockedHeight: null,
																		maxHeight: "240px",
																		maxWidth: "240px",
																		width: "32px",
																		backgroundColor: "",
																		backgroundRepeat: "no-repeat",
																		backgroundPosition: "center center",
																		backgroundImage: "",
																		backgroundSize: "auto",
																		borderRadius: "0px",
																		borderLeftColor: "#121212",
																		borderLeftStyle: "solid",
																		borderLeftWidth: "0px",
																		borderBottomColor: "#121212",
																		borderBottomStyle: "solid",
																		borderBottomWidth: "0px",
																		borderRightColor: "#121212",
																		borderRightStyle: "solid",
																		borderRightWidth: "0px",
																		borderTopColor: "#121212",
																		borderTopStyle: "solid",
																		borderTopWidth: "0px",
																		marginLeft: "0px",
																		marginBottom: "0px",
																		marginRight: "0px",
																		marginTop: "0px",
																		paddingLeft: "0px",
																		paddingBottom: "0px",
																		paddingRight: "0px",
																		paddingTop: "0px",
																	},
																	customData: null,
																},
															],
															attrs: {
																hideOnMobile: false,
																lock: false,
															},
															style: {
																width: "47.833333333333336px",
																backgroundColor: "",
																backgroundRepeat: "no-repeat",
																backgroundPosition: "center center",
																backgroundImage: "",
																backgroundSize: "auto",
															},
															customData: {},
														},
														{
															eid: "-cUZBYAfi",
															type: "column",
															children: [
																{
																	eid: "s3a27p0wrM",
																	type: "image",
																	attrs: {
																		title: "",
																		link: "",
																		altText: "",
																		src: "https://chamaileon-sdk.github.io/example-jsons/assets/social-icons/ig-3-grey.png",
																	},
																	style: {
																		fullWidthOnMobile: false,
																		align: "center",
																		lockedWidth: null,
																		lockedHeight: null,
																		maxHeight: "240px",
																		maxWidth: "240px",
																		width: "32px",
																		backgroundColor: "",
																		backgroundRepeat: "no-repeat",
																		backgroundPosition: "center center",
																		backgroundImage: "",
																		backgroundSize: "auto",
																		borderRadius: "0px",
																		borderLeftColor: "#121212",
																		borderLeftStyle: "solid",
																		borderLeftWidth: "0px",
																		borderBottomColor: "#121212",
																		borderBottomStyle: "solid",
																		borderBottomWidth: "0px",
																		borderRightColor: "#121212",
																		borderRightStyle: "solid",
																		borderRightWidth: "0px",
																		borderTopColor: "#121212",
																		borderTopStyle: "solid",
																		borderTopWidth: "0px",
																		marginLeft: "0px",
																		marginBottom: "0px",
																		marginRight: "0px",
																		marginTop: "0px",
																		paddingLeft: "0px",
																		paddingBottom: "0px",
																		paddingRight: "0px",
																		paddingTop: "0px",
																	},
																	customData: {},
																},
															],
															attrs: {
																hideOnMobile: false,
																lock: false,
															},
															style: {
																width: "47.833333333333336px",
																backgroundColor: "",
																backgroundRepeat: "no-repeat",
																backgroundPosition: "center center",
																backgroundImage: "",
																backgroundSize: "auto",
															},
															customData: {},
														},
														{
															eid: "patfjFrju",
															type: "column",
															children: [
																{
																	eid: "pak2YLUz4S",
																	type: "image",
																	attrs: {
																		title: "",
																		link: "",
																		altText: "",
																		src: "https://chamaileon-sdk.github.io/example-jsons/assets/social-icons/PT-3-grey.png",
																	},
																	style: {
																		fullWidthOnMobile: false,
																		align: "center",
																		lockedWidth: null,
																		lockedHeight: null,
																		maxHeight: "240px",
																		maxWidth: "240px",
																		width: "32px",
																		backgroundColor: "",
																		backgroundRepeat: "no-repeat",
																		backgroundPosition: "center center",
																		backgroundImage: "",
																		backgroundSize: "auto",
																		borderRadius: "0px",
																		borderLeftColor: "#121212",
																		borderLeftStyle: "solid",
																		borderLeftWidth: "0px",
																		borderBottomColor: "#121212",
																		borderBottomStyle: "solid",
																		borderBottomWidth: "0px",
																		borderRightColor: "#121212",
																		borderRightStyle: "solid",
																		borderRightWidth: "0px",
																		borderTopColor: "#121212",
																		borderTopStyle: "solid",
																		borderTopWidth: "0px",
																		marginLeft: "0px",
																		marginBottom: "0px",
																		marginRight: "0px",
																		marginTop: "0px",
																		paddingLeft: "0px",
																		paddingBottom: "0px",
																		paddingRight: "0px",
																		paddingTop: "0px",
																	},
																	customData: {},
																},
															],
															attrs: {
																hideOnMobile: false,
																lock: false,
															},
															style: {
																width: "47.833333333333336px",
																backgroundColor: "",
																backgroundRepeat: "no-repeat",
																backgroundPosition: "center center",
																backgroundImage: "",
																backgroundSize: "auto",
															},
															customData: {},
														},
														{
															eid: "pLkZ5OQ1P",
															type: "column",
															children: [
																{
																	eid: "s491WwUIxC",
																	type: "image",
																	attrs: {
																		title: "",
																		link: "",
																		altText: "",
																		src: "https://chamaileon-sdk.github.io/example-jsons/assets/social-icons/WC-3-grey.png",
																	},
																	style: {
																		fullWidthOnMobile: false,
																		align: "center",
																		lockedWidth: null,
																		lockedHeight: null,
																		maxHeight: "240px",
																		maxWidth: "240px",
																		width: "32px",
																		backgroundColor: "",
																		backgroundRepeat: "no-repeat",
																		backgroundPosition: "center center",
																		backgroundImage: "",
																		backgroundSize: "auto",
																		borderRadius: "0px",
																		borderLeftColor: "#121212",
																		borderLeftStyle: "solid",
																		borderLeftWidth: "0px",
																		borderBottomColor: "#121212",
																		borderBottomStyle: "solid",
																		borderBottomWidth: "0px",
																		borderRightColor: "#121212",
																		borderRightStyle: "solid",
																		borderRightWidth: "0px",
																		borderTopColor: "#121212",
																		borderTopStyle: "solid",
																		borderTopWidth: "0px",
																		marginLeft: "0px",
																		marginBottom: "0px",
																		marginRight: "0px",
																		marginTop: "0px",
																		paddingLeft: "0px",
																		paddingBottom: "0px",
																		paddingRight: "0px",
																		paddingTop: "0px",
																	},
																	customData: {},
																},
															],
															attrs: {
																hideOnMobile: false,
																lock: false,
															},
															style: {
																width: "47.833333333333336px",
																backgroundColor: "",
																backgroundRepeat: "no-repeat",
																backgroundPosition: "center center",
																backgroundImage: "",
																backgroundSize: "auto",
															},
															customData: {},
														},
														{
															eid: "Cw_G85Prva",
															type: "column",
															children: [
																{
																	eid: "X-uwTGOue",
																	type: "image",
																	attrs: {
																		title: "",
																		link: "",
																		altText: "",
																		src: "https://chamaileon-sdk.github.io/example-jsons/assets/social-icons/tw-3-grey.png",
																	},
																	style: {
																		fullWidthOnMobile: false,
																		align: "center",
																		lockedWidth: null,
																		lockedHeight: null,
																		maxHeight: "240px",
																		maxWidth: "240px",
																		width: "32px",
																		backgroundColor: "",
																		backgroundRepeat: "no-repeat",
																		backgroundPosition: "center center",
																		backgroundImage: "",
																		backgroundSize: "auto",
																		borderRadius: "0px",
																		borderLeftColor: "#121212",
																		borderLeftStyle: "solid",
																		borderLeftWidth: "0px",
																		borderBottomColor: "#121212",
																		borderBottomStyle: "solid",
																		borderBottomWidth: "0px",
																		borderRightColor: "#121212",
																		borderRightStyle: "solid",
																		borderRightWidth: "0px",
																		borderTopColor: "#121212",
																		borderTopStyle: "solid",
																		borderTopWidth: "0px",
																		marginLeft: "0px",
																		marginBottom: "0px",
																		marginRight: "0px",
																		marginTop: "0px",
																		paddingLeft: "0px",
																		paddingBottom: "0px",
																		paddingRight: "0px",
																		paddingTop: "0px",
																	},
																	customData: {},
																},
															],
															attrs: {
																hideOnMobile: false,
																lock: false,
															},
															style: {
																width: "47.833333333333336px",
																backgroundColor: "",
																backgroundRepeat: "no-repeat",
																backgroundPosition: "center center",
																backgroundImage: "",
																backgroundSize: "auto",
															},
															customData: {},
														},
													],
													attrs: {
														hideOnMobile: false,
														hideOnDesktop: false,
														stacking: "left-on-top",
														spacerBefore: "0px",
														spacerBetween: "0px",
														spacerAfter: "0px",
														spacerBeforeMobile: "0px",
														spacerBetweenMobile: "0px",
														spacerAfterMobile: "0px",
													},
													style: {
														backgroundColor: "",
														backgroundRepeat: "no-repeat",
														backgroundPosition: "center center",
														backgroundImage: "",
														backgroundSize: "auto",
													},
													customData: {},
												},
											],
											attrs: {
												hideOnMobile: false,
												hideOnDesktop: false,
											},
											style: {
												backgroundColor: "",
												backgroundRepeat: "no-repeat",
												backgroundPosition: "center center",
												backgroundImage: "",
												backgroundSize: "auto",
												borderRadius: "0px",
												borderLeftColor: "#121212",
												borderLeftStyle: "solid",
												borderLeftWidth: "0px",
												borderBottomColor: "#121212",
												borderBottomStyle: "solid",
												borderBottomWidth: "0px",
												borderRightColor: "#121212",
												borderRightStyle: "solid",
												borderRightWidth: "0px",
												borderTopColor: "#121212",
												borderTopStyle: "solid",
												borderTopWidth: "0px",
												marginLeft: "0px",
												marginBottom: "0px",
												marginRight: "0px",
												marginTop: "0px",
												paddingLeft: "10px",
												paddingBottom: "10px",
												paddingRight: "10px",
												paddingTop: "14px",
											},
											customData: {},
										},
									],
									attrs: {
										hideOnMobile: false,
										lock: false,
									},
									style: {
										width: "307px",
										backgroundColor: "",
										backgroundRepeat: "no-repeat",
										backgroundPosition: "center center",
										backgroundImage: "",
										backgroundSize: "auto",
									},
									customData: {},
								},
							],
							attrs: {
								hideOnMobile: false,
								hideOnDesktop: false,
								stacking: "left-on-top",
								spacerBefore: "0px",
								spacerBetween: "0px",
								spacerAfter: "0px",
								spacerBeforeMobile: "0px",
								spacerBetweenMobile: "0px",
								spacerAfterMobile: "10px",
							},
							style: {
								backgroundColor: "",
								backgroundRepeat: "no-repeat",
								backgroundPosition: "center center",
								backgroundImage: "",
								backgroundSize: "auto",
							},
							customData: {},
						},
					],
					placeholder: [],
					attrs: {
						hideOnMobile: false,
						hideOnDesktop: false,
						lock: false,
						marker: "",
					},
					style: {
						backgroundColor: "",
						backgroundRepeat: "no-repeat",
						backgroundPosition: "center center",
						backgroundImage: "",
						backgroundSize: "auto",
						contentBackgroundColor: {
							reference: "PrimaryColor",
							default: "#165BB4",
						},
						contentBackgroundRepeat: "no-repeat",
						contentBackgroundPosition: "center center",
						contentBackgroundImage: "",
						contentBackgroundSize: "auto",
						contentBorderRadius: "0px",
						contentBorderLeftColor: "#121212",
						contentBorderLeftStyle: "solid",
						contentBorderLeftWidth: "0px",
						contentBorderBottomColor: "#121212",
						contentBorderBottomStyle: "solid",
						contentBorderBottomWidth: "0px",
						contentBorderRightColor: "#121212",
						contentBorderRightStyle: "solid",
						contentBorderRightWidth: "0px",
						contentBorderTopColor: "#121212",
						contentBorderTopStyle: "solid",
						contentBorderTopWidth: "0px",
						contentMarginLeft: "0px",
						contentMarginBottom: "0px",
						contentMarginRight: "0px",
						contentMarginTop: "0px",
						contentPaddingLeft: "10px",
						contentPaddingBottom: "10px",
						contentPaddingRight: "10px",
						contentPaddingTop: "10px",
						contentWidth: 600,
						bodyWidth: 600,
					},
					customData: {},
				},
			],
			attrs: {},
			style: {
				backgroundColor: "#E4E8F1",
				backgroundRepeat: "repeat",
				backgroundPosition: "center center",
				backgroundImage: "",
				backgroundSize: "auto",
				bodyWidth: 600,
			},
			version: "4.0.0",
			customData: {},
		},
		title: "Business Promo",
		previewText: "",
		subjectLine: "",

		variables: [
			{
				name: "PrimaryColor",
				value: "#1762C5",
				type: "color",
			},
			{
				name: "SecondaryColor",
				value: "#5C9AEB",
				type: "color",
			},
		],
		components: [],
		fontFiles: {},
	};
};

export default {
	state: getDefaultState(),
	mutations: {
		updateDocument(state, payload) {
			state.title = payload.title;
			state.body = payload.body;
			state.variables = payload.variables;
			state.fontFiles = payload.fontFiles;
			state.components = payload.components;
		},
		resetEmailDocumentState(state) {
			Object.assign(state, getDefaultState());
		},
	},
	actions: {
		updateDocument({ commit }, payload) {
			commit("updateDocument", payload);
		},
	},
	getters: {
		documentTitle: state => state.title,
	},
};
